export const DictionaryPhotoshop_de_DE = [
    {
        id: 1,
        label: 'Photoshop > Über Photoshop...',
        placement: 'MenuBar',
        name: 'Über Photoshop...',
    },
    {
        id: 10,
        label: 'Datei > Neu...',
        placement: 'MenuBar',
        name: 'Neu...',
    },
    {
        id: 20,
        label: 'Datei > Öffnen...',
        placement: 'MenuBar',
        name: 'Öffnen...',
    },
    {
        id: 22,
        label: 'Datei > Als Smartobjekt öffnen...',
        placement: 'MenuBar',
        name: 'Als Smartobjekt öffnen...',
    },
    {
        id: 30,
        label: 'Datei > Speichern',
        placement: 'MenuBar',
        name: 'Speichern',
    },
    {
        id: 31,
        label: 'Datei > Schließen',
        placement: 'MenuBar',
        name: 'Schließen',
    },
    {
        id: 32,
        label: 'Datei > Speichern unter...',
        placement: 'MenuBar',
        name: 'Speichern unter...',
    },
    {
        id: 33,
        label: 'Datei > Kopie speichern...',
        placement: 'MenuBar',
        name: 'Kopie speichern...',
    },
    {
        id: 34,
        label: 'Datei > Zurück zur letzten Version',
        placement: 'MenuBar',
        name: 'Zurück zur letzten Version',
    },
    {
        id: 36,
        label: 'Photoshop > Photoshop beenden',
        placement: 'MenuBar',
        name: 'Photoshop beenden',
    },
    {
        id: 37,
        label: 'Datei > Alle schließen',
        placement: 'MenuBar',
        name: 'Alle schließen',
    },
    {
        id: 46,
        label: 'Datei > Sonstige schließen',
        placement: 'MenuBar',
        name: 'Sonstige schließen',
    },
    {
        id: 101,
        label: 'Bearbeiten > Rückgängig',
        placement: 'MenuBar',
        name: 'Rückgängig',
    },
    {
        id: 103,
        label: 'Bearbeiten > Ausschneiden',
        placement: 'MenuBar',
        name: 'Ausschneiden',
    },
    {
        id: 104,
        label: 'Bearbeiten > Kopieren',
        placement: 'MenuBar',
        name: 'Kopieren',
    },
    {
        id: 105,
        label: 'Bearbeiten > Einfügen',
        placement: 'MenuBar',
        name: 'Einfügen',
    },
    {
        id: 106,
        label: 'Bearbeiten > Löschen',
        placement: 'MenuBar',
        name: 'Löschen',
    },
    {
        id: 132,
        label: 'Bearbeiten > Wiederholen',
        placement: 'MenuBar',
        name: 'Wiederholen',
    },
    {
        id: 133,
        label: 'Bearbeiten > Letzten Status ein/aus',
        placement: 'MenuBar',
        name: 'Letzten Status ein/aus',
    },
    {
        id: 177,
        label: 'Datei > Eine Kopie drucken',
        placement: 'MenuBar',
        name: 'Eine Kopie drucken',
    },
    {
        id: 1001,
        label: 'Fenster > Anordnen > Neues Fenster',
        placement: 'MenuBar',
        name: 'Neues Fenster',
    },
    {
        id: 1002,
        label: 'Ansicht > Lineale',
        placement: 'MenuBar',
        name: 'Lineale',
    },
    {
        id: 1004,
        label: 'Ansicht > Einzoomen',
        placement: 'MenuBar',
        name: 'Einzoomen',
    },
    {
        id: 1005,
        label: 'Ansicht > Auszoomen',
        placement: 'MenuBar',
        name: 'Auszoomen',
    },
    {
        id: 1006,
        label: 'Bild > Modus > Bitmap',
        placement: 'MenuBar',
        name: 'Bitmap',
    },
    {
        id: 1007,
        label: 'Bild > Modus > Graustufen',
        placement: 'MenuBar',
        name: 'Graustufen',
    },
    {
        id: 1008,
        label: 'Bild > Modus > Duplex',
        placement: 'MenuBar',
        name: 'Duplex',
    },
    {
        id: 1009,
        label: 'Bild > Modus > Indizierte Farbe',
        placement: 'MenuBar',
        name: 'Indizierte Farbe',
    },
    {
        id: 1010,
        label: 'Bild > Modus > RGB-Farbe',
        placement: 'MenuBar',
        name: 'RGB-Farbe',
    },
    {
        id: 1011,
        label: 'Bild > Modus > CMYK-Farbe',
        placement: 'MenuBar',
        name: 'CMYK-Farbe',
    },
    {
        id: 1014,
        label: 'Bild > Modus > Mehrkanal',
        placement: 'MenuBar',
        name: 'Mehrkanal',
    },
    {
        id: 1016,
        label: 'Auswahl > Auswahl aufheben',
        placement: 'MenuBar',
        name: 'Auswahl aufheben',
    },
    {
        id: 1017,
        label: 'Auswahl > Alles auswählen',
        placement: 'MenuBar',
        name: 'Alles auswählen',
    },
    {
        id: 1018,
        label: 'Auswahl > Auswahl umkehren',
        placement: 'MenuBar',
        name: 'Auswahl umkehren',
    },
    {
        id: 1019,
        label: 'Filter > Letzter Filter',
        placement: 'MenuBar',
        name: 'Letzter Filter',
    },
    {
        id: 1021,
        label: 'Fenster > Kanäle',
        placement: 'MenuBar',
        name: 'Kanäle',
    },
    {
        id: 1025,
        label: 'Fenster > Pinseleinstellungen',
        placement: 'MenuBar',
        name: 'Pinseleinstellungen',
    },
    {
        id: 1029,
        label: 'Bearbeiten > Pinselvorgabe festlegen...',
        placement: 'MenuBar',
        name: 'Pinselvorgabe festlegen...',
    },
    {
        id: 1030,
        label: 'Bild > Bildgröße...',
        placement: 'MenuBar',
        name: 'Bildgröße...',
    },
    {
        id: 1031,
        label: 'Bild > Arbeitsfläche...',
        placement: 'MenuBar',
        name: 'Arbeitsfläche...',
    },
    {
        id: 1032,
        label: 'Datei > Platzieren und einbetten...',
        placement: 'MenuBar',
        name: 'Platzieren und einbetten...',
    },
    {
        id: 1033,
        label: 'Auswahl > Auswahl vergrößern',
        placement: 'MenuBar',
        name: 'Auswahl vergrößern',
    },
    {
        id: 1034,
        label: 'Auswahl > Ähnliches auswählen',
        placement: 'MenuBar',
        name: 'Ähnliches auswählen',
    },
    {
        id: 1035,
        label: 'Auswahl > Auswahl verändern > Rand...',
        placement: 'MenuBar',
        name: 'Rand...',
    },
    {
        id: 1036,
        label: 'Auswahl > Auswahl verändern > Weiche Kante...',
        placement: 'MenuBar',
        name: 'Weiche Kante...',
    },
    {
        id: 1037,
        label: 'Ebene > Matting > Rand entfernen...',
        placement: 'MenuBar',
        name: 'Rand entfernen...',
    },
    {
        id: 1038,
        label: 'Bearbeiten > Muster festlegen...',
        placement: 'MenuBar',
        name: 'Muster festlegen...',
    },
    {
        id: 1040,
        label: 'Bearbeiten > Einfügen Spezial > In die Auswahl einfügen',
        placement: 'MenuBar',
        name: 'In die Auswahl einfügen',
    },
    {
        id: 1042,
        label: 'Bearbeiten > Fläche füllen...',
        placement: 'MenuBar',
        name: 'Fläche füllen...',
    },
    {
        id: 1043,
        label: 'Bearbeiten > Kontur füllen...',
        placement: 'MenuBar',
        name: 'Kontur füllen...',
    },
    {
        id: 1044,
        label: 'Bild > Freistellen',
        placement: 'MenuBar',
        name: 'Freistellen',
    },
    {
        id: 1045,
        label: 'Bild > Modus > Farbtabelle...',
        placement: 'MenuBar',
        name: 'Farbtabelle...',
    },
    {
        id: 1046,
        label: 'Fenster > Farbe',
        placement: 'MenuBar',
        name: 'Farbe',
    },
    {
        id: 1052,
        label: 'Bild > Modus > Lab-Farbe',
        placement: 'MenuBar',
        name: 'Lab-Farbe',
    },
    {
        id: 1055,
        label: 'Fenster > Info',
        placement: 'MenuBar',
        name: 'Info',
    },
    {
        id: 1058,
        label: 'Fenster > Kopierquelle',
        placement: 'MenuBar',
        name: 'Kopierquelle',
    },
    {
        id: 1065,
        label: 'Fenster > Pfade',
        placement: 'MenuBar',
        name: 'Pfade',
    },
    {
        id: 1080,
        label: 'Bild > Zuschneiden...',
        placement: 'MenuBar',
        name: 'Zuschneiden...',
    },
    {
        id: 1081,
        label: 'Bild > Alles einblenden',
        placement: 'MenuBar',
        name: 'Alles einblenden',
    },
    {
        id: 1093,
        label: 'Bild > Überfüllen...',
        placement: 'MenuBar',
        name: 'Überfüllen...',
    },
    {
        id: 1098,
        label: 'Fenster > Ebenen',
        placement: 'MenuBar',
        name: 'Ebenen',
    },
    {
        id: 1099,
        label: 'Ebene > Neu > Ebene...',
        placement: 'MenuBar',
        name: 'Ebene...',
    },
    {
        id: 1100,
        label: 'Ebene > Löschen > Ebene',
        placement: 'MenuBar',
        name: 'Ebene',
    },
    {
        id: 1103,
        label: 'Ebene > Ebeneninhalt-Optionen...',
        placement: 'MenuBar',
        name: 'Ebeneninhalt-Optionen...',
    },
    {
        id: 1105,
        label: 'Ansicht > Farbproof',
        placement: 'MenuBar',
        name: 'Farbproof',
    },
    {
        id: 1106,
        label: 'Ansicht > Farbumfang-Warnung',
        placement: 'MenuBar',
        name: 'Farbumfang-Warnung',
    },
    {
        id: 1107,
        label: 'Bearbeiten > Auf eine Ebene reduziert kopieren',
        placement: 'MenuBar',
        name: 'Auf eine Ebene reduziert kopieren',
    },
    {
        id: 1108,
        label: 'Auswahl > Auswahl verändern > Abrunden...',
        placement: 'MenuBar',
        name: 'Abrunden...',
    },
    {
        id: 1109,
        label: 'Auswahl > Auswahl verändern > Erweitern...',
        placement: 'MenuBar',
        name: 'Erweitern...',
    },
    {
        id: 1110,
        label: 'Auswahl > Auswahl verändern > Verkleinern...',
        placement: 'MenuBar',
        name: 'Verkleinern...',
    },
    {
        id: 1111,
        label: 'Fenster > Optionen',
        placement: 'MenuBar',
        name: 'Optionen',
    },
    {
        id: 1112,
        label: 'Ansicht > Pixelseitenverhältnis-Korrektur',
        placement: 'MenuBar',
        name: 'Pixelseitenverhältnis-Korrektur',
    },
    {
        id: 1114,
        label: 'Ebene > Ebenen ausblenden',
        placement: 'MenuBar',
        name: 'Ebenen ausblenden',
    },
    {
        id: 1115,
        label: 'Auswahl > Auswählen und maskieren...',
        placement: 'MenuBar',
        name: 'Auswählen und maskieren...',
    },
    {
        id: 1119,
        label: 'Fenster > Farbfelder',
        placement: 'MenuBar',
        name: 'Farbfelder',
    },
    {
        id: 1134,
        label: 'Bild > Duplizieren...',
        placement: 'MenuBar',
        name: 'Duplizieren...',
    },
    {
        id: 1135,
        label: 'Ebene > Ebene duplizieren...',
        placement: 'MenuBar',
        name: 'Ebene duplizieren...',
    },
    {
        id: 1137,
        label: 'Datei > Dateiinformationen...',
        placement: 'MenuBar',
        name: 'Dateiinformationen...',
    },
    {
        id: 1139,
        label: 'Ebene > Sichtbare auf eine Ebene reduzieren',
        placement: 'MenuBar',
        name: 'Sichtbare auf eine Ebene reduzieren',
    },
    {
        id: 1141,
        label: 'Ebene > Auf Hintergrundebene reduzieren',
        placement: 'MenuBar',
        name: 'Auf Hintergrundebene reduzieren',
    },
    {
        id: 1152,
        label: 'Auswahl > Farbbereich...',
        placement: 'MenuBar',
        name: 'Farbbereich...',
    },
    {
        id: 1153,
        label: 'Bild > Bildberechnungen...',
        placement: 'MenuBar',
        name: 'Bildberechnungen...',
    },
    {
        id: 1154,
        label: 'Bearbeiten > Verblassen...',
        placement: 'MenuBar',
        name: 'Verblassen...',
    },
    {
        id: 1156,
        label: 'Ebene > Ebenenmaske > Alle ausblenden',
        placement: 'MenuBar',
        name: 'Alle ausblenden',
    },
    {
        id: 1157,
        label: 'Ebene > Ebenenmaske > Alle einblenden',
        placement: 'MenuBar',
        name: 'Alle einblenden',
    },
    {
        id: 1158,
        label: 'Ebene > Ebenenmaske > Auswahl einblenden',
        placement: 'MenuBar',
        name: 'Auswahl einblenden',
    },
    {
        id: 1159,
        label: 'Ebene > Ebenenmaske > Aktivieren',
        placement: 'MenuBar',
        name: 'Aktivieren',
    },
    {
        id: 1161,
        label: 'Bild > Modus > 8 Bit/Kanal',
        placement: 'MenuBar',
        name: '8 Bit/Kanal',
    },
    {
        id: 1162,
        label: 'Bild > Modus > 16 Bit/Kanal',
        placement: 'MenuBar',
        name: '16 Bit/Kanal',
    },
    {
        id: 1163,
        label: 'Fenster > Navigator',
        placement: 'MenuBar',
        name: 'Navigator',
    },
    {
        id: 1166,
        label: 'Ebene > Auf eine Ebene reduzieren',
        placement: 'MenuBar',
        name: 'Auf eine Ebene reduzieren',
    },
    {
        id: 1167,
        label: 'Fenster > Ebenenkomposition',
        placement: 'MenuBar',
        name: 'Ebenenkomposition',
    },
    {
        id: 1168,
        label: 'Ebene > Ebenenmaske > Auswahl ausblenden',
        placement: 'MenuBar',
        name: 'Auswahl ausblenden',
    },
    {
        id: 1169,
        label: 'Datei > Automatisieren > Droplet erstellen...',
        placement: 'MenuBar',
        name: 'Droplet erstellen...',
    },
    {
        id: 1170,
        label: 'Fenster > Aktionen',
        placement: 'MenuBar',
        name: 'Aktionen',
    },
    {
        id: 1180,
        label: 'Datei > Automatisieren > Stapelverarbeitung...',
        placement: 'MenuBar',
        name: 'Stapelverarbeitung...',
    },
    {
        id: 1188,
        label: 'Fenster > Zeitleiste',
        placement: 'MenuBar',
        name: 'Zeitleiste',
    },
    {
        id: 1190,
        label: 'Ansicht > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: 'Ansicht > Druckformat',
        placement: 'MenuBar',
        name: 'Druckformat',
    },
    {
        id: 1192,
        label: 'Ansicht > Ganzes Bild',
        placement: 'MenuBar',
        name: 'Ganzes Bild',
    },
    {
        id: 1194,
        label: 'Fenster > Werkzeuge',
        placement: 'MenuBar',
        name: 'Werkzeuge',
    },
    {
        id: 1195,
        label: 'Ansicht > Zeichenfläche an Bildschirm anpassen',
        placement: 'MenuBar',
        name: 'Zeichenfläche an Bildschirm anpassen',
    },
    {
        id: 1199,
        label: 'Fenster > Protokoll',
        placement: 'MenuBar',
        name: 'Protokoll',
    },
    {
        id: 1200,
        label: 'Auswahl > Auswahl laden...',
        placement: 'MenuBar',
        name: 'Auswahl laden...',
    },
    {
        id: 1202,
        label: 'Ansicht > Pixel-Seitenverhältnis > Eigenes Pixel-Seitenverhältnis...',
        placement: 'MenuBar',
        name: 'Eigenes Pixel-Seitenverhältnis...',
    },
    {
        id: 1203,
        label: 'Ansicht > Pixel-Seitenverhältnis > Pixel-Seitenverhältnis löschen...',
        placement: 'MenuBar',
        name: 'Pixel-Seitenverhältnis löschen...',
    },
    {
        id: 1204,
        label: 'Ansicht > Pixel-Seitenverhältnis > Pixel-Seitenverhältnis zurücksetzen...',
        placement: 'MenuBar',
        name: 'Pixel-Seitenverhältnis zurücksetzen...',
    },
    {
        id: 1205,
        label: 'Ansicht > Pixel-Seitenverhältnis > Quadratisch',
        placement: 'MenuBar',
        name: 'Quadratisch',
    },
    {
        id: 1206,
        label: 'Bild > Modus > 32 Bit/Kanal',
        placement: 'MenuBar',
        name: '32 Bit/Kanal',
    },
    {
        id: 1211,
        label: 'Bearbeiten > Vorgaben > Vorgaben migrieren',
        placement: 'MenuBar',
        name: 'Vorgaben migrieren',
    },
    {
        id: 1212,
        label: 'Bearbeiten > Profil zuweisen...',
        placement: 'MenuBar',
        name: 'Profil zuweisen...',
    },
    {
        id: 1213,
        label: 'Bearbeiten > In Profil umwandeln...',
        placement: 'MenuBar',
        name: 'In Profil umwandeln...',
    },
    {
        id: 1214,
        label: 'Bearbeiten > Vorgaben > Vorgaben-Manager...',
        placement: 'MenuBar',
        name: 'Vorgaben-Manager...',
    },
    {
        id: 1215,
        label: 'Bearbeiten > Adobe PDF-Vorgaben...',
        placement: 'MenuBar',
        name: 'Adobe PDF-Vorgaben...',
    },
    {
        id: 1217,
        label: 'Ansicht > Originalgröße',
        placement: 'MenuBar',
        name: 'Originalgröße',
    },
    {
        id: 1223,
        label: 'Schrift > Ausrichtung > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 1224,
        label: 'Schrift > Ausrichtung > Vertikal',
        placement: 'MenuBar',
        name: 'Vertikal',
    },
    {
        id: 1228,
        label: 'Schrift > Arbeitspfad erstellen',
        placement: 'MenuBar',
        name: 'Arbeitspfad erstellen',
    },
    {
        id: 1229,
        label: 'Schrift > In Form umwandeln',
        placement: 'MenuBar',
        name: 'In Form umwandeln',
    },
    {
        id: 1231,
        label: 'Ebene > Ausrichten > Obere Kanten',
        placement: 'MenuBar',
        name: 'Obere Kanten',
    },
    {
        id: 1232,
        label: 'Ebene > Ausrichten > Untere Kanten',
        placement: 'MenuBar',
        name: 'Untere Kanten',
    },
    {
        id: 1233,
        label: 'Ebene > Ausrichten > Vertikale Mitten',
        placement: 'MenuBar',
        name: 'Vertikale Mitten',
    },
    {
        id: 1234,
        label: 'Ebene > Ausrichten > Linke Kanten',
        placement: 'MenuBar',
        name: 'Linke Kanten',
    },
    {
        id: 1235,
        label: 'Ebene > Ausrichten > Rechte Kanten',
        placement: 'MenuBar',
        name: 'Rechte Kanten',
    },
    {
        id: 1236,
        label: 'Ebene > Ausrichten > Horizontale Mitten',
        placement: 'MenuBar',
        name: 'Horizontale Mitten',
    },
    {
        id: 1237,
        label: 'Bearbeiten > Ebenen automatisch ausrichten...',
        placement: 'MenuBar',
        name: 'Ebenen automatisch ausrichten...',
    },
    {
        id: 1238,
        label: 'Bearbeiten > Ebenen automatisch überblenden...',
        placement: 'MenuBar',
        name: 'Ebenen automatisch überblenden...',
    },
    {
        id: 1239,
        label: 'Ebene > Verteilen > Vertikal',
        placement: 'MenuBar',
        name: 'Vertikal',
    },
    {
        id: 1241,
        label: 'Ebene > Verteilen > Obere Kanten',
        placement: 'MenuBar',
        name: 'Obere Kanten',
    },
    {
        id: 1242,
        label: 'Ebene > Verteilen > Untere Kanten',
        placement: 'MenuBar',
        name: 'Untere Kanten',
    },
    {
        id: 1243,
        label: 'Ebene > Verteilen > Vertikale Mitten',
        placement: 'MenuBar',
        name: 'Vertikale Mitten',
    },
    {
        id: 1245,
        label: 'Ebene > Verteilen > Linke Kanten',
        placement: 'MenuBar',
        name: 'Linke Kanten',
    },
    {
        id: 1246,
        label: 'Ebene > Verteilen > Rechte Kanten',
        placement: 'MenuBar',
        name: 'Rechte Kanten',
    },
    {
        id: 1247,
        label: 'Ebene > Verteilen > Horizontale Mitten',
        placement: 'MenuBar',
        name: 'Horizontale Mitten',
    },
    {
        id: 1249,
        label: 'Ebene > Verteilen > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 1281,
        label: 'Auswahl > Auswahl speichern...',
        placement: 'MenuBar',
        name: 'Auswahl speichern...',
    },
    {
        id: 1284,
        label: 'Ansicht > Horizontal spiegeln',
        placement: 'MenuBar',
        name: 'Horizontal spiegeln',
    },
    {
        id: 1285,
        label: 'Ansicht > Mustervorschau',
        placement: 'MenuBar',
        name: 'Mustervorschau',
    },
    {
        id: 1292,
        label: 'Ebene > Ebenenmaske > Aus Transparenz',
        placement: 'MenuBar',
        name: 'Aus Transparenz',
    },
    {
        id: 1295,
        label: 'Ebene > Matting > Farbdekontaminierung...',
        placement: 'MenuBar',
        name: 'Farbdekontaminierung...',
    },
    {
        id: 1297,
        label: 'Bearbeiten > Einfügen Spezial > An Originalposition einfügen',
        placement: 'MenuBar',
        name: 'An Originalposition einfügen',
    },
    {
        id: 1299,
        label: 'Ansicht > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: 'Ebene > Ebenenstil > Schlagschatten...',
        placement: 'MenuBar',
        name: 'Schlagschatten...',
    },
    {
        id: 1302,
        label: 'Ebene > Ebenenstil > Schatten nach innen...',
        placement: 'MenuBar',
        name: 'Schatten nach innen...',
    },
    {
        id: 1303,
        label: 'Ebene > Ebenenstil > Schein nach außen...',
        placement: 'MenuBar',
        name: 'Schein nach außen...',
    },
    {
        id: 1304,
        label: 'Ebene > Ebenenstil > Schein nach innen...',
        placement: 'MenuBar',
        name: 'Schein nach innen...',
    },
    {
        id: 1305,
        label: 'Ebene > Ebenenstil > Abgeflachte Kante und Relief...',
        placement: 'MenuBar',
        name: 'Abgeflachte Kante und Relief...',
    },
    {
        id: 1306,
        label: 'Ebene > Ebenenstil > Alle Effekte ausblenden',
        placement: 'MenuBar',
        name: 'Alle Effekte ausblenden',
    },
    {
        id: 1307,
        label: 'Ebene > Ebenenstil > Globaler Lichteinfall...',
        placement: 'MenuBar',
        name: 'Globaler Lichteinfall...',
    },
    {
        id: 1308,
        label: 'Ebene > Ebenenstil > Ebenen erstellen',
        placement: 'MenuBar',
        name: 'Ebenen erstellen',
    },
    {
        id: 1312,
        label: 'Ebene > Ebenenstil > Glanz...',
        placement: 'MenuBar',
        name: 'Glanz...',
    },
    {
        id: 1313,
        label: 'Ebene > Ebenenstil > Kontur...',
        placement: 'MenuBar',
        name: 'Kontur...',
    },
    {
        id: 1314,
        label: 'Ebene > Ebenenstil > Ebenenstil kopieren',
        placement: 'MenuBar',
        name: 'Ebenenstil kopieren',
    },
    {
        id: 1315,
        label: 'Ebene > Ebenenstil > Ebenenstil einfügen',
        placement: 'MenuBar',
        name: 'Ebenenstil einfügen',
    },
    {
        id: 1327,
        label: 'Ebene > Ebenenstil > Effekte skalieren...',
        placement: 'MenuBar',
        name: 'Effekte skalieren...',
    },
    {
        id: 1331,
        label: 'Ebene > Ebenenstil > Fülloptionen...',
        placement: 'MenuBar',
        name: 'Fülloptionen...',
    },
    {
        id: 1335,
        label: 'Ebene > Ebenenstil > Farbüberlagerung...',
        placement: 'MenuBar',
        name: 'Farbüberlagerung...',
    },
    {
        id: 1336,
        label: 'Ebene > Ebenenstil > Verlaufsüberlagerung...',
        placement: 'MenuBar',
        name: 'Verlaufsüberlagerung...',
    },
    {
        id: 1337,
        label: 'Ebene > Ebenenstil > Musterüberlagerung...',
        placement: 'MenuBar',
        name: 'Musterüberlagerung...',
    },
    {
        id: 1339,
        label: 'Ebene > Ebenenstil > Ebenenstil löschen',
        placement: 'MenuBar',
        name: 'Ebenenstil löschen',
    },
    {
        id: 1355,
        label: 'Fenster > Anmerkungen',
        placement: 'MenuBar',
        name: 'Anmerkungen',
    },
    {
        id: 1382,
        label: 'Fenster > Histogramm',
        placement: 'MenuBar',
        name: 'Histogramm',
    },
    {
        id: 1396,
        label: 'Fenster > Pinsel',
        placement: 'MenuBar',
        name: 'Pinsel',
    },
    {
        id: 1429,
        label: 'Plug-ins > Plug-ins-Bedienfeld',
        placement: 'MenuBar',
        name: 'Plug-ins-Bedienfeld',
    },
    {
        id: 1430,
        label: 'Plug-ins > Plug-ins durchsuchen...',
        placement: 'MenuBar',
        name: 'Plug-ins durchsuchen...',
    },
    {
        id: 1431,
        label: 'Plug-ins > Plug-ins verwalten...',
        placement: 'MenuBar',
        name: 'Plug-ins verwalten...',
    },
    {
        id: 1460,
        label: 'Auswahl > Fokusbereich…',
        placement: 'MenuBar',
        name: 'Fokusbereich…',
    },
    {
        id: 1461,
        label: 'Auswahl > Motiv',
        placement: 'MenuBar',
        name: 'Motiv',
    },
    {
        id: 1462,
        label: 'Auswahl > Himmel',
        placement: 'MenuBar',
        name: 'Himmel',
    },
    {
        id: 1502,
        label: 'Datei > Importieren > Bilder von Gerät...',
        placement: 'MenuBar',
        name: 'Bilder von Gerät...',
    },
    {
        id: 1503,
        label: 'Datei > Von iPhone oder iPad importieren',
        placement: 'MenuBar',
        name: 'Von iPhone oder iPad importieren',
    },
    {
        id: 1510,
        label: 'Bearbeiten > Inhaltsbasierte Füllung...',
        placement: 'MenuBar',
        name: 'Inhaltsbasierte Füllung...',
    },
    {
        id: 1520,
        label: 'Datei > In Bridge suchen...',
        placement: 'MenuBar',
        name: 'In Bridge suchen...',
    },
    {
        id: 1522,
        label: 'Schrift > Mehr zu Adobe Fonts…',
        placement: 'MenuBar',
        name: 'Mehr zu Adobe Fonts…',
    },
    {
        id: 1530,
        label: 'Datei > Schließen und zu Bridge gehen...',
        placement: 'MenuBar',
        name: 'Schließen und zu Bridge gehen...',
    },
    {
        id: 1613,
        label: 'Bearbeiten > Remoteverbindungen...',
        placement: 'MenuBar',
        name: 'Remoteverbindungen...',
    },
    {
        id: 1676,
        label: 'Datei > Skripte > Durchsuchen...',
        placement: 'MenuBar',
        name: 'Durchsuchen...',
    },
    {
        id: 1695,
        label: 'Datei > Exportieren > Für Web speichern...',
        placement: 'MenuBar',
        name: 'Für Web speichern...',
    },
    {
        id: 1696,
        label: 'Datei > Automatisieren > PDF-Präsentation...',
        placement: 'MenuBar',
        name: 'PDF-Präsentation...',
    },
    {
        id: 1701,
        label: 'Bild > Korrekturen > Umkehren',
        placement: 'MenuBar',
        name: 'Umkehren',
    },
    {
        id: 1702,
        label: 'Bild > Korrekturen > Tonwertangleichung',
        placement: 'MenuBar',
        name: 'Tonwertangleichung',
    },
    {
        id: 1703,
        label: 'Bild > Korrekturen > Schwellenwert...',
        placement: 'MenuBar',
        name: 'Schwellenwert...',
    },
    {
        id: 1704,
        label: 'Bild > Korrekturen > Tontrennung...',
        placement: 'MenuBar',
        name: 'Tontrennung...',
    },
    {
        id: 1750,
        label: 'Bearbeiten > Generatives Füllen...',
        placement: 'MenuBar',
        name: 'Generatives Füllen...',
    },
    {
        id: 1771,
        label: 'Bearbeiten > Bild generieren…',
        placement: 'MenuBar',
        name: 'Bild generieren…',
    },
    {
        id: 1776,
        label: 'Bild > Generativ hochskalieren...',
        placement: 'MenuBar',
        name: 'Generativ hochskalieren...',
    },
    {
        id: 1777,
        label: 'Filter > KI-Entrauschen…',
        placement: 'MenuBar',
        name: 'KI-Entrauschen…',
    },
    {
        id: 1778,
        label: 'Filter > KI-Scharfzeichnen…',
        placement: 'MenuBar',
        name: 'KI-Scharfzeichnen…',
    },
    {
        id: 1801,
        label: 'Bild > Korrekturen > Tonwertkorrektur...',
        placement: 'MenuBar',
        name: 'Tonwertkorrektur...',
    },
    {
        id: 1802,
        label: 'Bild > Korrekturen > Gradationskurven...',
        placement: 'MenuBar',
        name: 'Gradationskurven...',
    },
    {
        id: 1803,
        label: 'Bild > Korrekturen > Helligkeit/Kontrast...',
        placement: 'MenuBar',
        name: 'Helligkeit/Kontrast...',
    },
    {
        id: 1804,
        label: 'Bild > Korrekturen > Farbbalance...',
        placement: 'MenuBar',
        name: 'Farbbalance...',
    },
    {
        id: 1805,
        label: 'Bild > Korrekturen > Farbton/Sättigung...',
        placement: 'MenuBar',
        name: 'Farbton/Sättigung...',
    },
    {
        id: 1806,
        label: 'Bild > Korrekturen > Farbe ersetzen...',
        placement: 'MenuBar',
        name: 'Farbe ersetzen...',
    },
    {
        id: 1807,
        label: 'Bild > Korrekturen > Selektive Farbkorrektur...',
        placement: 'MenuBar',
        name: 'Selektive Farbkorrektur...',
    },
    {
        id: 1808,
        label: 'Bild > Auto-Farbton',
        placement: 'MenuBar',
        name: 'Auto-Farbton',
    },
    {
        id: 1809,
        label: 'Bild > Korrekturen > Sättigung verringern',
        placement: 'MenuBar',
        name: 'Sättigung verringern',
    },
    {
        id: 1810,
        label: 'Bild > Auto-Kontrast',
        placement: 'MenuBar',
        name: 'Auto-Kontrast',
    },
    {
        id: 1817,
        label: 'Bild > Auto-Farbe',
        placement: 'MenuBar',
        name: 'Auto-Farbe',
    },
    {
        id: 1822,
        label: 'Bild > Korrekturen > Gleiche Farbe...',
        placement: 'MenuBar',
        name: 'Gleiche Farbe...',
    },
    {
        id: 1824,
        label: 'Bild > Korrekturen > Schwarzweiß...',
        placement: 'MenuBar',
        name: 'Schwarzweiß...',
    },
    {
        id: 1827,
        label: 'Bild > Korrekturen > Dynamik...',
        placement: 'MenuBar',
        name: 'Dynamik...',
    },
    {
        id: 1900,
        label: 'Bild > Kanalberechnungen...',
        placement: 'MenuBar',
        name: 'Kanalberechnungen...',
    },
    {
        id: 1942,
        label: 'Ebene > Neu > Hintergrund',
        placement: 'MenuBar',
        name: 'Hintergrund',
    },
    {
        id: 1943,
        label: 'Auswahl > Erneut auswählen',
        placement: 'MenuBar',
        name: 'Erneut auswählen',
    },
    {
        id: 1953,
        label: 'Ebene > Vektormaske > Alle ausblenden',
        placement: 'MenuBar',
        name: 'Alle ausblenden',
    },
    {
        id: 1954,
        label: 'Ebene > Vektormaske > Alle einblenden',
        placement: 'MenuBar',
        name: 'Alle einblenden',
    },
    {
        id: 1955,
        label: 'Ebene > Vektormaske > Aktueller Pfad',
        placement: 'MenuBar',
        name: 'Aktueller Pfad',
    },
    {
        id: 1956,
        label: 'Ebene > Vektormaske > Löschen',
        placement: 'MenuBar',
        name: 'Löschen',
    },
    {
        id: 1957,
        label: 'Ebene > Rastern > Vektormaske',
        placement: 'MenuBar',
        name: 'Vektormaske',
    },
    {
        id: 1959,
        label: 'Ebene > Vektormaske > Aktivieren',
        placement: 'MenuBar',
        name: 'Aktivieren',
    },
    {
        id: 1971,
        label: 'Auswahl > Auswahl transformieren',
        placement: 'MenuBar',
        name: 'Auswahl transformieren',
    },
    {
        id: 2101,
        label: 'Datei > Drucken...',
        placement: 'MenuBar',
        name: 'Drucken...',
    },
    {
        id: 2103,
        label: 'Datei > Letzte Dateien öffnen > Liste der letzten Dateien löschen',
        placement: 'MenuBar',
        name: 'Liste der letzten Dateien löschen',
    },
    {
        id: 2109,
        label: 'Ebene > Vektormaske > Verknüpfen',
        placement: 'MenuBar',
        name: 'Verknüpfen',
    },
    {
        id: 2201,
        label: 'Bearbeiten > Transformieren > Skalieren',
        placement: 'MenuBar',
        name: 'Skalieren',
    },
    {
        id: 2202,
        label: 'Bearbeiten > Transformieren > Neigen',
        placement: 'MenuBar',
        name: 'Neigen',
    },
    {
        id: 2203,
        label: 'Bearbeiten > Transformieren > Perspektivisch',
        placement: 'MenuBar',
        name: 'Perspektivisch',
    },
    {
        id: 2204,
        label: 'Bearbeiten > Transformieren > Verzerren',
        placement: 'MenuBar',
        name: 'Verzerren',
    },
    {
        id: 2205,
        label: 'Bearbeiten > Transformieren > Drehen',
        placement: 'MenuBar',
        name: 'Drehen',
    },
    {
        id: 2207,
        label: 'Bearbeiten > Frei transformieren',
        placement: 'MenuBar',
        name: 'Frei transformieren',
    },
    {
        id: 2208,
        label: 'Bearbeiten > Transformieren > Um 180° drehen',
        placement: 'MenuBar',
        name: 'Um 180° drehen',
    },
    {
        id: 2209,
        label: 'Bearbeiten > Transformieren > 90° im Uhrzeigersinn drehen',
        placement: 'MenuBar',
        name: '90° im Uhrzeigersinn drehen',
    },
    {
        id: 2210,
        label: 'Bearbeiten > Transformieren > 90° gegen den Uhrzeigersinn drehen',
        placement: 'MenuBar',
        name: '90° gegen den Uhrzeigersinn drehen',
    },
    {
        id: 2211,
        label: 'Bearbeiten > Transformieren > Horizontal spiegeln',
        placement: 'MenuBar',
        name: 'Horizontal spiegeln',
    },
    {
        id: 2212,
        label: 'Bearbeiten > Transformieren > Vertikal spiegeln',
        placement: 'MenuBar',
        name: 'Vertikal spiegeln',
    },
    {
        id: 2217,
        label: 'Bearbeiten > Transformieren > Erneut',
        placement: 'MenuBar',
        name: 'Erneut',
    },
    {
        id: 2218,
        label: 'Schrift > Text verformen...',
        placement: 'MenuBar',
        name: 'Text verformen...',
    },
    {
        id: 2219,
        label: 'Bearbeiten > Transformieren > Verformen',
        placement: 'MenuBar',
        name: 'Verformen',
    },
    {
        id: 2220,
        label: 'Bearbeiten > Inhaltsbasiert skalieren',
        placement: 'MenuBar',
        name: 'Inhaltsbasiert skalieren',
    },
    {
        id: 2221,
        label: 'Bearbeiten > Formgitter',
        placement: 'MenuBar',
        name: 'Formgitter',
    },
    {
        id: 2224,
        label: 'Filter > Weichzeichnergalerie > Iris-Weichzeichnung...',
        placement: 'MenuBar',
        name: 'Iris-Weichzeichnung...',
    },
    {
        id: 2225,
        label: 'Filter > Weichzeichnergalerie > Feld-Weichzeichnung...',
        placement: 'MenuBar',
        name: 'Feld-Weichzeichnung...',
    },
    {
        id: 2226,
        label: 'Filter > Weichzeichnergalerie > Tilt-Shift...',
        placement: 'MenuBar',
        name: 'Tilt-Shift...',
    },
    {
        id: 2227,
        label: 'Filter > Weichzeichnergalerie > Pfad-Weichzeichnung...',
        placement: 'MenuBar',
        name: 'Pfad-Weichzeichnung...',
    },
    {
        id: 2229,
        label: 'Filter > Weichzeichnergalerie > Kreisförmige Weichzeichnung…',
        placement: 'MenuBar',
        name: 'Kreisförmige Weichzeichnung…',
    },
    {
        id: 2231,
        label: 'Filter > Renderfilter > Flamme…',
        placement: 'MenuBar',
        name: 'Flamme…',
    },
    {
        id: 2232,
        label: 'Filter > Renderfilter > Bilderrahmen...',
        placement: 'MenuBar',
        name: 'Bilderrahmen...',
    },
    {
        id: 2233,
        label: 'Filter > Renderfilter > Baum...',
        placement: 'MenuBar',
        name: 'Baum...',
    },
    {
        id: 2250,
        label: 'Bearbeiten > Transformieren > Verkrümmung horizontal teilen',
        placement: 'MenuBar',
        name: 'Verkrümmung horizontal teilen',
    },
    {
        id: 2251,
        label: 'Bearbeiten > Transformieren > Verkrümmung vertikal teilen',
        placement: 'MenuBar',
        name: 'Verkrümmung vertikal teilen',
    },
    {
        id: 2252,
        label: 'Bearbeiten > Transformieren > Verkrümmung quer teilen',
        placement: 'MenuBar',
        name: 'Verkrümmung quer teilen',
    },
    {
        id: 2253,
        label: 'Bearbeiten > Transformieren > Verkrümmungsteilung entfernen',
        placement: 'MenuBar',
        name: 'Verkrümmungsteilung entfernen',
    },
    {
        id: 2254,
        label: 'Bearbeiten > Transformieren > Hilfslinien aktivieren/deaktivieren',
        placement: 'MenuBar',
        name: 'Hilfslinien aktivieren/deaktivieren',
    },
    {
        id: 2255,
        label: 'Bearbeiten > Transformieren > Ankerpunkt für Verkrümmung konvertieren',
        placement: 'MenuBar',
        name: 'Ankerpunkt für Verkrümmung konvertieren',
    },
    {
        id: 2260,
        label: 'Bearbeiten > Himmel austauschen...',
        placement: 'MenuBar',
        name: 'Himmel austauschen...',
    },
    {
        id: 2304,
        label: 'Photoshop > Voreinstellungen > Leistung...',
        placement: 'MenuBar',
        name: 'Leistung...',
    },
    {
        id: 2311,
        label: 'Photoshop > Voreinstellungen > Allgemein...',
        placement: 'MenuBar',
        name: 'Allgemein...',
    },
    {
        id: 2312,
        label: 'Photoshop > Voreinstellungen > Zeigerdarstellung...',
        placement: 'MenuBar',
        name: 'Zeigerdarstellung...',
    },
    {
        id: 2313,
        label: 'Photoshop > Voreinstellungen > Transparenz & Farbumfang-Warnung...',
        placement: 'MenuBar',
        name: 'Transparenz & Farbumfang-Warnung...',
    },
    {
        id: 2314,
        label: 'Photoshop > Voreinstellungen > Maßeinheiten & Lineale...',
        placement: 'MenuBar',
        name: 'Maßeinheiten & Lineale...',
    },
    {
        id: 2315,
        label: 'Photoshop > Voreinstellungen > Hilfslinien, Raster und Slices...',
        placement: 'MenuBar',
        name: 'Hilfslinien, Raster und Slices...',
    },
    {
        id: 2316,
        label: 'Photoshop > Voreinstellungen > Plug-ins...',
        placement: 'MenuBar',
        name: 'Plug-ins...',
    },
    {
        id: 2317,
        label: 'Photoshop > Voreinstellungen > Dateihandhabung...',
        placement: 'MenuBar',
        name: 'Dateihandhabung...',
    },
    {
        id: 2322,
        label: 'Photoshop > Voreinstellungen > Schrift...',
        placement: 'MenuBar',
        name: 'Schrift...',
    },
    {
        id: 2323,
        label: 'Photoshop > Voreinstellungen > Benutzeroberfläche...',
        placement: 'MenuBar',
        name: 'Benutzeroberfläche...',
    },
    {
        id: 2324,
        label: 'Photoshop > Voreinstellungen > Camera Raw...',
        placement: 'MenuBar',
        name: 'Camera Raw...',
    },
    {
        id: 2327,
        label: 'Photoshop > Voreinstellungen > Technologievorschau...',
        placement: 'MenuBar',
        name: 'Technologievorschau...',
    },
    {
        id: 2328,
        label: 'Photoshop > Voreinstellungen > Arbeitsvolumes...',
        placement: 'MenuBar',
        name: 'Arbeitsvolumes...',
    },
    {
        id: 2329,
        label: 'Photoshop > Voreinstellungen > Verlauf und Content Credentials...',
        placement: 'MenuBar',
        name: 'Verlauf und Content Credentials...',
    },
    {
        id: 2330,
        label: 'Photoshop > Voreinstellungen > Werkzeuge...',
        placement: 'MenuBar',
        name: 'Werkzeuge...',
    },
    {
        id: 2331,
        label: 'Photoshop > Voreinstellungen > Arbeitsbereich...',
        placement: 'MenuBar',
        name: 'Arbeitsbereich...',
    },
    {
        id: 2332,
        label: 'Photoshop > Voreinstellungen > Exportieren...',
        placement: 'MenuBar',
        name: 'Exportieren...',
    },
    {
        id: 2332,
        label: 'Datei > Exportieren > Export-Voreinstellungen...',
        placement: 'MenuBar',
        name: 'Export-Voreinstellungen...',
    },
    {
        id: 2333,
        label: 'Photoshop > Voreinstellungen > Verbesserte Steuerung...',
        placement: 'MenuBar',
        name: 'Verbesserte Steuerung...',
    },
    {
        id: 2335,
        label: 'Photoshop > Voreinstellungen > Bildverarbeitung...',
        placement: 'MenuBar',
        name: 'Bildverarbeitung...',
    },
    {
        id: 2337,
        label: 'Photoshop > Voreinstellungen > Benachrichtigungen...',
        placement: 'MenuBar',
        name: 'Benachrichtigungen...',
    },
    {
        id: 2344,
        label: 'Bearbeiten > Farbeinstellungen...',
        placement: 'MenuBar',
        name: 'Farbeinstellungen...',
    },
    {
        id: 2345,
        label: 'Bearbeiten > OpenColorIO-Einstellungen...',
        placement: 'MenuBar',
        name: 'OpenColorIO-Einstellungen...',
    },
    {
        id: 2361,
        label: 'Bearbeiten > Entleeren > Protokolle',
        placement: 'MenuBar',
        name: 'Protokolle',
    },
    {
        id: 2701,
        label: 'Ebene > Matting > Schwarz entfernen',
        placement: 'MenuBar',
        name: 'Schwarz entfernen',
    },
    {
        id: 2703,
        label: 'Ebene > Matting > Weiß entfernen',
        placement: 'MenuBar',
        name: 'Weiß entfernen',
    },
    {
        id: 2711,
        label: 'Ebene > Anordnen > In den Vordergrund',
        placement: 'MenuBar',
        name: 'In den Vordergrund',
    },
    {
        id: 2712,
        label: 'Ebene > Anordnen > Schrittweise nach vorne',
        placement: 'MenuBar',
        name: 'Schrittweise nach vorne',
    },
    {
        id: 2713,
        label: 'Ebene > Anordnen > Schrittweise nach hinten',
        placement: 'MenuBar',
        name: 'Schrittweise nach hinten',
    },
    {
        id: 2714,
        label: 'Ebene > Anordnen > In den Hintergrund',
        placement: 'MenuBar',
        name: 'In den Hintergrund',
    },
    {
        id: 2715,
        label: 'Ebene > Anordnen > Umkehren',
        placement: 'MenuBar',
        name: 'Umkehren',
    },
    {
        id: 2769,
        label: 'Ebene > Smartfilter > Mehrere Smartfilter deaktivieren',
        placement: 'MenuBar',
        name: 'Mehrere Smartfilter deaktivieren',
    },
    {
        id: 2770,
        label: 'Ebene > Smartfilter > Smartfilter löschen',
        placement: 'MenuBar',
        name: 'Smartfilter löschen',
    },
    {
        id: 2802,
        label: 'Ansicht > Proof einrichten > Benutzerdefiniert...',
        placement: 'MenuBar',
        name: 'Benutzerdefiniert...',
    },
    {
        id: 2803,
        label: 'Ansicht > Proof einrichten > CMYK-Arbeitsfarbraum',
        placement: 'MenuBar',
        name: 'CMYK-Arbeitsfarbraum',
    },
    {
        id: 2804,
        label: 'Ansicht > Proof einrichten > Cyan-Platte Arbeitsfarbraum',
        placement: 'MenuBar',
        name: 'Cyan-Platte Arbeitsfarbraum',
    },
    {
        id: 2805,
        label: 'Ansicht > Proof einrichten > Magenta-Platte Arbeitsfarbraum',
        placement: 'MenuBar',
        name: 'Magenta-Platte Arbeitsfarbraum',
    },
    {
        id: 2806,
        label: 'Ansicht > Proof einrichten > Gelbe Platte Arbeitsfarbraum',
        placement: 'MenuBar',
        name: 'Gelbe Platte Arbeitsfarbraum',
    },
    {
        id: 2807,
        label: 'Ansicht > Proof einrichten > Schwarze Platte Arbeitsfarbraum',
        placement: 'MenuBar',
        name: 'Schwarze Platte Arbeitsfarbraum',
    },
    {
        id: 2808,
        label: 'Ansicht > Proof einrichten > CMY-Platten Arbeitsfarbraum',
        placement: 'MenuBar',
        name: 'CMY-Platten Arbeitsfarbraum',
    },
    {
        id: 2809,
        label: 'Ansicht > Proof einrichten > Altes Macintosh-RGB (Gamma 1.8)',
        placement: 'MenuBar',
        name: 'Altes Macintosh-RGB (Gamma 1.8)',
    },
    {
        id: 2810,
        label: 'Ansicht > Proof einrichten > Internet-Standard-RGB (sRGB)',
        placement: 'MenuBar',
        name: 'Internet-Standard-RGB (sRGB)',
    },
    {
        id: 2811,
        label: 'Ansicht > Proof einrichten > Monitor-RGB',
        placement: 'MenuBar',
        name: 'Monitor-RGB',
    },
    {
        id: 2815,
        label: 'Ansicht > Proof einrichten > Farbenblindheit (Protanopie)',
        placement: 'MenuBar',
        name: 'Farbenblindheit (Protanopie)',
    },
    {
        id: 2816,
        label: 'Ansicht > Proof einrichten > Farbenblindheit (Deuteranopie)',
        placement: 'MenuBar',
        name: 'Farbenblindheit (Deuteranopie)',
    },
    {
        id: 2820,
        label: 'Bild > Analyse > Linealwerkzeug',
        placement: 'MenuBar',
        name: 'Linealwerkzeug',
    },
    {
        id: 2830,
        label: 'Bild > Analyse > Skalenmarkierung platzieren...',
        placement: 'MenuBar',
        name: 'Skalenmarkierung platzieren...',
    },
    {
        id: 2841,
        label: 'Bild > Analyse > Messskala festlegen > Standard',
        placement: 'MenuBar',
        name: 'Standard',
    },
    {
        id: 2842,
        label: 'Bild > Analyse > Messskala festlegen > Benutzerdefiniert...',
        placement: 'MenuBar',
        name: 'Benutzerdefiniert...',
    },
    {
        id: 2851,
        label: 'Bild > Analyse > Datenpunkte auswählen > Benutzerdefiniert...',
        placement: 'MenuBar',
        name: 'Benutzerdefiniert...',
    },
    {
        id: 2860,
        label: 'Bild > Analyse > Messungen aufzeichnen',
        placement: 'MenuBar',
        name: 'Messungen aufzeichnen',
    },
    {
        id: 2880,
        label: 'Fenster > Messprotokoll',
        placement: 'MenuBar',
        name: 'Messprotokoll',
    },
    {
        id: 2912,
        label: 'Bearbeiten > Entleeren > Zwischenablage',
        placement: 'MenuBar',
        name: 'Zwischenablage',
    },
    {
        id: 2915,
        label: 'Bearbeiten > Entleeren > Alles',
        placement: 'MenuBar',
        name: 'Alles',
    },
    {
        id: 2920,
        label: 'Bearbeiten > Entleeren > Video Cache',
        placement: 'MenuBar',
        name: 'Video Cache',
    },
    {
        id: 2939,
        label: 'Fenster > Arbeitsbereich > Arbeitsbereich sperren',
        placement: 'MenuBar',
        name: 'Arbeitsbereich sperren',
    },
    {
        id: 2940,
        label: 'Ansicht > Hilfslinien > Hilfslinien sperren',
        placement: 'MenuBar',
        name: 'Hilfslinien sperren',
    },
    {
        id: 2950,
        label: 'Ansicht > Hilfslinien > Hilfslinien löschen',
        placement: 'MenuBar',
        name: 'Hilfslinien löschen',
    },
    {
        id: 2951,
        label: 'Ebene > Löschen > Ausgeblendete Ebenen',
        placement: 'MenuBar',
        name: 'Ausgeblendete Ebenen',
    },
    {
        id: 2952,
        label: 'Ansicht > Hilfslinien > Ausgewählte Hilfslinien der Zeichenfläche löschen',
        placement: 'MenuBar',
        name: 'Ausgewählte Hilfslinien der Zeichenfläche löschen',
    },
    {
        id: 2953,
        label: 'Ansicht > Hilfslinien > Hilfslinien der Arbeitsfläche löschen',
        placement: 'MenuBar',
        name: 'Hilfslinien der Arbeitsfläche löschen',
    },
    {
        id: 2956,
        label: 'Ebene > Neu > Gruppe aus Ebenen...',
        placement: 'MenuBar',
        name: 'Gruppe aus Ebenen...',
    },
    {
        id: 2957,
        label: 'Ebene > Ebenen fixieren...',
        placement: 'MenuBar',
        name: 'Ebenen fixieren...',
    },
    {
        id: 2958,
        label: 'Ebene > Ebenen gruppieren',
        placement: 'MenuBar',
        name: 'Ebenen gruppieren',
    },
    {
        id: 2959,
        label: 'Ebene > Ebenengruppierung aufheben',
        placement: 'MenuBar',
        name: 'Ebenengruppierung aufheben',
    },
    {
        id: 2960,
        label: 'Ebene > Verbundene Ebenen auswählen',
        placement: 'MenuBar',
        name: 'Verbundene Ebenen auswählen',
    },
    {
        id: 2961,
        label: 'Ebene > Ebenen verbinden',
        placement: 'MenuBar',
        name: 'Ebenen verbinden',
    },
    {
        id: 2962,
        label: 'Auswahl > Alle Ebenen',
        placement: 'MenuBar',
        name: 'Alle Ebenen',
    },
    {
        id: 2963,
        label: 'Auswahl > Ebenenauswahl aufheben',
        placement: 'MenuBar',
        name: 'Ebenenauswahl aufheben',
    },
    {
        id: 2967,
        label: 'Ansicht > Slices fixieren',
        placement: 'MenuBar',
        name: 'Slices fixieren',
    },
    {
        id: 2969,
        label: 'Ansicht > Slices löschen',
        placement: 'MenuBar',
        name: 'Slices löschen',
    },
    {
        id: 2970,
        label: 'Ebene > Neu > Ebene durch Kopie',
        placement: 'MenuBar',
        name: 'Ebene durch Kopie',
    },
    {
        id: 2971,
        label: 'Ebene > Neu > Ebene durch Ausschneiden',
        placement: 'MenuBar',
        name: 'Ebene durch Ausschneiden',
    },
    {
        id: 2972,
        label: 'Ebene > Schnittmaske erstellen',
        placement: 'MenuBar',
        name: 'Schnittmaske erstellen',
    },
    {
        id: 2976,
        label: 'Ebene > Neu > Gruppe...',
        placement: 'MenuBar',
        name: 'Gruppe...',
    },
    {
        id: 2980,
        label: 'Ebene > Smartobjekte > In Smartobjekt konvertieren',
        placement: 'MenuBar',
        name: 'In Smartobjekt konvertieren',
    },
    {
        id: 2981,
        label: 'Ebene > Smartobjekte > Neues Smartobjekt durch Kopie',
        placement: 'MenuBar',
        name: 'Neues Smartobjekt durch Kopie',
    },
    {
        id: 2982,
        label: 'Auswahl > Ebenen suchen',
        placement: 'MenuBar',
        name: 'Ebenen suchen',
    },
    {
        id: 2983,
        label: 'Ebene > Ebene umbenennen...',
        placement: 'MenuBar',
        name: 'Ebene umbenennen...',
    },
    {
        id: 2986,
        label: 'Auswahl > Ebenen isolieren',
        placement: 'MenuBar',
        name: 'Ebenen isolieren',
    },
    {
        id: 2991,
        label: 'Bild > Bilddrehung > 90° Im Uhrzeigersinn',
        placement: 'MenuBar',
        name: '90° Im Uhrzeigersinn',
    },
    {
        id: 2992,
        label: 'Bild > Bilddrehung > 90° Gegen den Uhrzeigersinn',
        placement: 'MenuBar',
        name: '90° Gegen den Uhrzeigersinn',
    },
    {
        id: 2993,
        label: 'Bild > Bilddrehung > 180°',
        placement: 'MenuBar',
        name: '180°',
    },
    {
        id: 2994,
        label: 'Bild > Bilddrehung > Per Eingabe...',
        placement: 'MenuBar',
        name: 'Per Eingabe...',
    },
    {
        id: 2996,
        label: 'Bild > Bilddrehung > Arbeitsfläche horizontal spiegeln',
        placement: 'MenuBar',
        name: 'Arbeitsfläche horizontal spiegeln',
    },
    {
        id: 2997,
        label: 'Bild > Bilddrehung > Arbeitsfläche vertikal spiegeln',
        placement: 'MenuBar',
        name: 'Arbeitsfläche vertikal spiegeln',
    },
    {
        id: 3056,
        label: 'Bild > Korrekturen > Kanalmixer...',
        placement: 'MenuBar',
        name: 'Kanalmixer...',
    },
    {
        id: 3062,
        label: 'Bild > Korrekturen > Verlaufsumsetzung...',
        placement: 'MenuBar',
        name: 'Verlaufsumsetzung...',
    },
    {
        id: 3063,
        label: 'Bild > Korrekturen > Fotofilter...',
        placement: 'MenuBar',
        name: 'Fotofilter...',
    },
    {
        id: 3065,
        label: 'Bild > Korrekturen > Tiefen/Lichter...',
        placement: 'MenuBar',
        name: 'Tiefen/Lichter...',
    },
    {
        id: 3066,
        label: 'Bild > Korrekturen > Color Lookup...',
        placement: 'MenuBar',
        name: 'Color Lookup...',
    },
    {
        id: 3067,
        label: 'Bild > Korrekturen > Belichtung...',
        placement: 'MenuBar',
        name: 'Belichtung...',
    },
    {
        id: 3076,
        label: 'Ebene > Smartfilter > Filtermaske deaktivieren',
        placement: 'MenuBar',
        name: 'Filtermaske deaktivieren',
    },
    {
        id: 3083,
        label: 'Ebene > Neue Einstellungsebene > Belichtung...',
        placement: 'MenuBar',
        name: 'Belichtung...',
    },
    {
        id: 3085,
        label: 'Ebene > Neue Einstellungsebene > Farbe und Dynamik...',
        placement: 'MenuBar',
        name: 'Farbe und Dynamik...',
    },
    {
        id: 3090,
        label: 'Datei > Platzieren und verknüpfen...',
        placement: 'MenuBar',
        name: 'Platzieren und verknüpfen...',
    },
    {
        id: 3091,
        label: 'Ebene > Smartobjekte > Im Finder zeigen',
        placement: 'MenuBar',
        name: 'Im Finder zeigen',
    },
    {
        id: 3092,
        label: 'Datei > Verpacken...',
        placement: 'MenuBar',
        name: 'Verpacken...',
    },
    {
        id: 3098,
        label: 'Datei > Automatisieren > Generator-Plug-Ins',
        placement: 'MenuBar',
        name: 'Generator-Plug-Ins',
    },
    {
        id: 3187,
        label: 'Fenster > Stile',
        placement: 'MenuBar',
        name: 'Stile',
    },
    {
        id: 3300,
        label: 'Schrift > Bedienfelder > Zeichenbedienfeld',
        placement: 'MenuBar',
        name: 'Zeichenbedienfeld',
    },
    {
        id: 3300,
        label: 'Fenster > Zeichen',
        placement: 'MenuBar',
        name: 'Zeichen',
    },
    {
        id: 3309,
        label: 'Schrift > OpenType > Standardligaturen',
        placement: 'MenuBar',
        name: 'Standardligaturen',
    },
    {
        id: 3310,
        label: 'Schrift > OpenType > Renaissance-Antiqua',
        placement: 'MenuBar',
        name: 'Renaissance-Antiqua',
    },
    {
        id: 3327,
        label: 'Schrift > OpenType > Proportionale Metrik',
        placement: 'MenuBar',
        name: 'Proportionale Metrik',
    },
    {
        id: 3334,
        label: 'Schrift > OpenType > Schwungschrift',
        placement: 'MenuBar',
        name: 'Schwungschrift',
    },
    {
        id: 3338,
        label: 'Schrift > OpenType > Kontextbedingte Varianten',
        placement: 'MenuBar',
        name: 'Kontextbedingte Varianten',
    },
    {
        id: 3339,
        label: 'Schrift > OpenType > Bedingte Ligaturen',
        placement: 'MenuBar',
        name: 'Bedingte Ligaturen',
    },
    {
        id: 3340,
        label: 'Schrift > OpenType > Formatvarianten',
        placement: 'MenuBar',
        name: 'Formatvarianten',
    },
    {
        id: 3341,
        label: 'Schrift > OpenType > Titelschriftvarianten',
        placement: 'MenuBar',
        name: 'Titelschriftvarianten',
    },
    {
        id: 3342,
        label: 'Schrift > OpenType > Ornamente',
        placement: 'MenuBar',
        name: 'Ornamente',
    },
    {
        id: 3343,
        label: 'Schrift > OpenType > Ordinalzeichen',
        placement: 'MenuBar',
        name: 'Ordinalzeichen',
    },
    {
        id: 3344,
        label: 'Schrift > OpenType > Brüche',
        placement: 'MenuBar',
        name: 'Brüche',
    },
    {
        id: 3345,
        label: 'Schrift > OpenType > Japanisch 78',
        placement: 'MenuBar',
        name: 'Japanisch 78',
    },
    {
        id: 3346,
        label: 'Schrift > OpenType > Japanisch - Experte',
        placement: 'MenuBar',
        name: 'Japanisch - Experte',
    },
    {
        id: 3347,
        label: 'Schrift > OpenType > Japanisch - Traditionell',
        placement: 'MenuBar',
        name: 'Japanisch - Traditionell',
    },
    {
        id: 3348,
        label: 'Schrift > OpenType > Kana',
        placement: 'MenuBar',
        name: 'Kana',
    },
    {
        id: 3349,
        label: 'Schrift > OpenType > Lateinische Kursivschrift',
        placement: 'MenuBar',
        name: 'Lateinische Kursivschrift',
    },
    {
        id: 3350,
        label: 'Schrift > Bedienfelder > Absatzbedienfeld',
        placement: 'MenuBar',
        name: 'Absatzbedienfeld',
    },
    {
        id: 3350,
        label: 'Fenster > Absatz',
        placement: 'MenuBar',
        name: 'Absatz',
    },
    {
        id: 3370,
        label: 'Schrift > Antialiasing > Ohne',
        placement: 'MenuBar',
        name: 'Ohne',
    },
    {
        id: 3371,
        label: 'Schrift > Antialiasing > Präzise',
        placement: 'MenuBar',
        name: 'Präzise',
    },
    {
        id: 3372,
        label: 'Schrift > Antialiasing > Stark',
        placement: 'MenuBar',
        name: 'Stark',
    },
    {
        id: 3373,
        label: 'Schrift > Antialiasing > Abrunden',
        placement: 'MenuBar',
        name: 'Abrunden',
    },
    {
        id: 3374,
        label: 'Schrift > Antialiasing > Klar',
        placement: 'MenuBar',
        name: 'Klar',
    },
    {
        id: 3375,
        label: 'Schrift > Antialiasing > Mac-LCD',
        placement: 'MenuBar',
        name: 'Mac-LCD',
    },
    {
        id: 3376,
        label: 'Schrift > Antialiasing > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: 'Schrift > Textformtyp konvertieren',
        placement: 'MenuBar',
        name: 'Textformtyp konvertieren',
    },
    {
        id: 3390,
        label: 'Schrift > Alle Textebenen aktualisieren',
        placement: 'MenuBar',
        name: 'Alle Textebenen aktualisieren',
    },
    {
        id: 3392,
        label: 'Bearbeiten > Rechtschreibprüfung...',
        placement: 'MenuBar',
        name: 'Rechtschreibprüfung...',
    },
    {
        id: 3393,
        label: 'Bearbeiten > Text suchen und ersetzen...',
        placement: 'MenuBar',
        name: 'Text suchen und ersetzen...',
    },
    {
        id: 3409,
        label: 'Ebene > Formen kombinieren > Formen vereinigen',
        placement: 'MenuBar',
        name: 'Formen vereinigen',
    },
    {
        id: 3410,
        label: 'Ebene > Formen kombinieren > Vordere Form subtrahieren',
        placement: 'MenuBar',
        name: 'Vordere Form subtrahieren',
    },
    {
        id: 3411,
        label: 'Ebene > Formen kombinieren > Formen auf Überlappung vereinigen',
        placement: 'MenuBar',
        name: 'Formen auf Überlappung vereinigen',
    },
    {
        id: 3412,
        label: 'Ebene > Formen kombinieren > Formen auf Überlappung subtrahieren',
        placement: 'MenuBar',
        name: 'Formen auf Überlappung subtrahieren',
    },
    {
        id: 3438,
        label: 'Ebene > SVG kopieren',
        placement: 'MenuBar',
        name: 'SVG kopieren',
    },
    {
        id: 3439,
        label: 'Ebene > CSS kopieren',
        placement: 'MenuBar',
        name: 'CSS kopieren',
    },
    {
        id: 3443,
        label: 'Datei > Exportieren > Exportieren als...',
        placement: 'MenuBar',
        name: 'Exportieren als...',
    },
    {
        id: 3444,
        label: 'Datei > Exportieren > Schnell-Export als PNG',
        placement: 'MenuBar',
        name: 'Schnell-Export als PNG',
    },
    {
        id: 3446,
        label: 'Ebene > Schnell-Export als PNG',
        placement: 'MenuBar',
        name: 'Schnell-Export als PNG',
    },
    {
        id: 3447,
        label: 'Ebene > Exportieren als...',
        placement: 'MenuBar',
        name: 'Exportieren als...',
    },
    {
        id: 3451,
        label: 'Schrift > Sprachoptionen > LTR Arabische Zahlen – 123%',
        placement: 'MenuBar',
        name: 'LTR Arabische Zahlen – 123%',
    },
    {
        id: 3452,
        label: 'Schrift > Sprachoptionen > Farsi-Ziffern',
        placement: 'MenuBar',
        name: 'Farsi-Ziffern',
    },
    {
        id: 3453,
        label: 'Schrift > Sprachoptionen > Hindi-Ziffern',
        placement: 'MenuBar',
        name: 'Hindi-Ziffern',
    },
    {
        id: 3459,
        label: 'Schrift > Sprachoptionen > RTL Arabische Zahlen – %123',
        placement: 'MenuBar',
        name: 'RTL Arabische Zahlen – %123',
    },
    {
        id: 3500,
        label: 'Ansicht > Extras',
        placement: 'MenuBar',
        name: 'Extras',
    },
    {
        id: 3501,
        label: 'Ansicht > Anzeigen > Auswahlkanten',
        placement: 'MenuBar',
        name: 'Auswahlkanten',
    },
    {
        id: 3502,
        label: 'Ansicht > Anzeigen > Zielpfad',
        placement: 'MenuBar',
        name: 'Zielpfad',
    },
    {
        id: 3503,
        label: 'Ansicht > Anzeigen > Hilfslinien',
        placement: 'MenuBar',
        name: 'Hilfslinien',
    },
    {
        id: 3504,
        label: 'Ansicht > Anzeigen > Raster',
        placement: 'MenuBar',
        name: 'Raster',
    },
    {
        id: 3505,
        label: 'Ansicht > Anzeigen > Slices',
        placement: 'MenuBar',
        name: 'Slices',
    },
    {
        id: 3506,
        label: 'Ansicht > Anzeigen > Anmerkungen',
        placement: 'MenuBar',
        name: 'Anmerkungen',
    },
    {
        id: 3507,
        label: 'Ansicht > Anzeigen > Alles',
        placement: 'MenuBar',
        name: 'Alles',
    },
    {
        id: 3508,
        label: 'Ansicht > Anzeigen > Nichts',
        placement: 'MenuBar',
        name: 'Nichts',
    },
    {
        id: 3510,
        label: 'Ansicht > Anzeigen > Extra-Optionen einblenden...',
        placement: 'MenuBar',
        name: 'Extra-Optionen einblenden...',
    },
    {
        id: 3511,
        label: 'Ansicht > Anzeigen > Intelligente Hilfslinien',
        placement: 'MenuBar',
        name: 'Intelligente Hilfslinien',
    },
    {
        id: 3512,
        label: 'Ansicht > Anzeigen > Ebenenkanten',
        placement: 'MenuBar',
        name: 'Ebenenkanten',
    },
    {
        id: 3513,
        label: 'Ansicht > Anzeigen > Zählung',
        placement: 'MenuBar',
        name: 'Zählung',
    },
    {
        id: 3514,
        label: 'Ansicht > Anzeigen > Pixelraster',
        placement: 'MenuBar',
        name: 'Pixelraster',
    },
    {
        id: 3517,
        label: 'Ansicht > Anzeigen > Formgitter',
        placement: 'MenuBar',
        name: 'Formgitter',
    },
    {
        id: 3520,
        label: 'Ansicht > Ausrichten',
        placement: 'MenuBar',
        name: 'Ausrichten',
    },
    {
        id: 3521,
        label: 'Ansicht > Ausrichten an > Hilfslinien',
        placement: 'MenuBar',
        name: 'Hilfslinien',
    },
    {
        id: 3522,
        label: 'Ansicht > Ausrichten an > Raster',
        placement: 'MenuBar',
        name: 'Raster',
    },
    {
        id: 3523,
        label: 'Ansicht > Ausrichten an > Slices',
        placement: 'MenuBar',
        name: 'Slices',
    },
    {
        id: 3524,
        label: 'Ansicht > Ausrichten an > Dokumentbegrenzungen',
        placement: 'MenuBar',
        name: 'Dokumentbegrenzungen',
    },
    {
        id: 3527,
        label: 'Ansicht > Ausrichten an > An allen ausrichten',
        placement: 'MenuBar',
        name: 'An allen ausrichten',
    },
    {
        id: 3528,
        label: 'Ansicht > Ausrichten an > An nichts ausrichten',
        placement: 'MenuBar',
        name: 'An nichts ausrichten',
    },
    {
        id: 3530,
        label: 'Ansicht > Ausrichten an > Ebenen',
        placement: 'MenuBar',
        name: 'Ebenen',
    },
    {
        id: 3532,
        label: 'Ansicht > Anzeigen > Mustervorschau – Kachelbegrenz.',
        placement: 'MenuBar',
        name: 'Mustervorschau – Kachelbegrenz.',
    },
    {
        id: 3533,
        label: 'Ansicht > Anzeigen > Hilfslinien der Zeichenfläche',
        placement: 'MenuBar',
        name: 'Hilfslinien der Zeichenfläche',
    },
    {
        id: 3535,
        label: 'Ansicht > Anzeigen > Zeichenflächennamen',
        placement: 'MenuBar',
        name: 'Zeichenflächennamen',
    },
    {
        id: 3536,
        label: 'Ansicht > Anzeigen > Hilfslinien der Arbeitsfläche',
        placement: 'MenuBar',
        name: 'Hilfslinien der Arbeitsfläche',
    },
    {
        id: 3541,
        label: 'Ebene > Rastern > Form',
        placement: 'MenuBar',
        name: 'Form',
    },
    {
        id: 3542,
        label: 'Ebene > Rastern > Schrift',
        placement: 'MenuBar',
        name: 'Schrift',
    },
    {
        id: 3542,
        label: 'Schrift > Textebene rastern',
        placement: 'MenuBar',
        name: 'Textebene rastern',
    },
    {
        id: 3544,
        label: 'Ebene > Rastern > Füllfläche',
        placement: 'MenuBar',
        name: 'Füllfläche',
    },
    {
        id: 3545,
        label: 'Ebene > Rastern > Alle Ebenen',
        placement: 'MenuBar',
        name: 'Alle Ebenen',
    },
    {
        id: 3547,
        label: 'Ebene > Rastern > Ebene',
        placement: 'MenuBar',
        name: 'Ebene',
    },
    {
        id: 3549,
        label: 'Ebene > Smartobjekte > Rastern',
        placement: 'MenuBar',
        name: 'Rastern',
    },
    {
        id: 3549,
        label: 'Ebene > Rastern > Smartobjekt',
        placement: 'MenuBar',
        name: 'Smartobjekt',
    },
    {
        id: 3551,
        label: 'Ebene > Rastern > Video',
        placement: 'MenuBar',
        name: 'Video',
    },
    {
        id: 3553,
        label: 'Ebene > Rastern > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: 'Ebene > Videoebenen > Rastern',
        placement: 'MenuBar',
        name: 'Rastern',
    },
    {
        id: 3557,
        label: 'Ebene > Rastern > Ebenenstil',
        placement: 'MenuBar',
        name: 'Ebenenstil',
    },
    {
        id: 3561,
        label: 'Ebene > Rastern > Generativ',
        placement: 'MenuBar',
        name: 'Generativ',
    },
    {
        id: 3585,
        label: 'Ansicht > Anzeigen > Bearbeitungspins',
        placement: 'MenuBar',
        name: 'Bearbeitungspins',
    },
    {
        id: 3911,
        label: 'Filter > NextGen-Filter > Blur (Gaussian)',
        placement: 'MenuBar',
        name: 'Blur (Gaussian)',
    },
    {
        id: 4002,
        label: 'Hilfe > Aktualisierungen...',
        placement: 'MenuBar',
        name: 'Aktualisierungen...',
    },
    {
        id: 4210,
        label: 'Fenster > Werkzeugvorgaben',
        placement: 'MenuBar',
        name: 'Werkzeugvorgaben',
    },
    {
        id: 5059,
        label: 'Ebene > Ebenenmaske > Löschen',
        placement: 'MenuBar',
        name: 'Löschen',
    },
    {
        id: 5068,
        label: 'Bearbeiten > Einfügen Spezial > Außen einfügen',
        placement: 'MenuBar',
        name: 'Außen einfügen',
    },
    {
        id: 5069,
        label: 'Auswahl > Im Maskierungsmodus bearbeiten',
        placement: 'MenuBar',
        name: 'Im Maskierungsmodus bearbeiten',
    },
    {
        id: 5085,
        label: 'Ebene > Ebenenmaske > Verknüpfen',
        placement: 'MenuBar',
        name: 'Verknüpfen',
    },
    {
        id: 5095,
        label: 'Ebene > Ebenenmaske > Anwenden',
        placement: 'MenuBar',
        name: 'Anwenden',
    },
    {
        id: 5115,
        label: 'Fenster > Arbeitsbereich > Neuer Arbeitsbereich...',
        placement: 'MenuBar',
        name: 'Neuer Arbeitsbereich...',
    },
    {
        id: 5116,
        label: 'Fenster > Arbeitsbereich > Arbeitsbereich löschen...',
        placement: 'MenuBar',
        name: 'Arbeitsbereich löschen...',
    },
    {
        id: 5117,
        label: 'Fenster > Arbeitsbereich > Grundelemente zurücksetzen',
        placement: 'MenuBar',
        name: 'Grundelemente zurücksetzen',
    },
    {
        id: 5217,
        label: 'Ebene > Neues ebenenbasiertes Slice',
        placement: 'MenuBar',
        name: 'Neues ebenenbasiertes Slice',
    },
    {
        id: 5226,
        label: 'Ebene > Smartfilter > Filtermaske löschen',
        placement: 'MenuBar',
        name: 'Filtermaske löschen',
    },
    {
        id: 5613,
        label: 'Ansicht > Hilfslinien > Neue Hilfslinie...',
        placement: 'MenuBar',
        name: 'Neue Hilfslinie...',
    },
    {
        id: 5614,
        label: 'Ansicht > Hilfslinien > Neues Hilfslinienlayout...',
        placement: 'MenuBar',
        name: 'Neues Hilfslinienlayout...',
    },
    {
        id: 5615,
        label: 'Ansicht > Hilfslinien > Neue Hilfslinien aus Form',
        placement: 'MenuBar',
        name: 'Neue Hilfslinien aus Form',
    },
    {
        id: 5624,
        label: 'Bearbeiten > Eigene Form festlegen...',
        placement: 'MenuBar',
        name: 'Eigene Form festlegen...',
    },
    {
        id: 5634,
        label: 'Fenster > Arbeitsbereich > Grundelemente (Standard)',
        placement: 'MenuBar',
        name: 'Grundelemente (Standard)',
    },
    {
        id: 5929,
        label: 'Fenster > Anordnen > Alle in den Vordergrund',
        placement: 'MenuBar',
        name: 'Alle in den Vordergrund',
    },
    {
        id: 5930,
        label: 'Fenster > Anordnen > Überlappend',
        placement: 'MenuBar',
        name: 'Überlappend',
    },
    {
        id: 5931,
        label: 'Fenster > Anordnen > Kachel',
        placement: 'MenuBar',
        name: 'Kachel',
    },
    {
        id: 5932,
        label: 'Fenster > Anordnen > Minimieren',
        placement: 'MenuBar',
        name: 'Minimieren',
    },
    {
        id: 5933,
        label: 'Fenster > Anordnen > Alle nebeneinander',
        placement: 'MenuBar',
        name: 'Alle nebeneinander',
    },
    {
        id: 5934,
        label: 'Fenster > Anordnen > Alle übereinander',
        placement: 'MenuBar',
        name: 'Alle übereinander',
    },
    {
        id: 5935,
        label: 'Fenster > Anordnen > 2 übereinander',
        placement: 'MenuBar',
        name: '2 übereinander',
    },
    {
        id: 5936,
        label: 'Fenster > Anordnen > 2 nebeneinander',
        placement: 'MenuBar',
        name: '2 nebeneinander',
    },
    {
        id: 5937,
        label: 'Fenster > Anordnen > 3 übereinander',
        placement: 'MenuBar',
        name: '3 übereinander',
    },
    {
        id: 5938,
        label: 'Fenster > Anordnen > 3 nebeneinander',
        placement: 'MenuBar',
        name: '3 nebeneinander',
    },
    {
        id: 5939,
        label: 'Fenster > Anordnen > 1 links und 2 rechts',
        placement: 'MenuBar',
        name: '1 links und 2 rechts',
    },
    {
        id: 5940,
        label: 'Fenster > Anordnen > 4',
        placement: 'MenuBar',
        name: '4',
    },
    {
        id: 5941,
        label: 'Fenster > Anordnen > 6',
        placement: 'MenuBar',
        name: '6',
    },
    {
        id: 5956,
        label: 'Hilfe > Photoshop-Hilfe...',
        placement: 'MenuBar',
        name: 'Photoshop-Hilfe...',
    },
    {
        id: 5957,
        label: 'Bearbeiten > Suchen',
        placement: 'MenuBar',
        name: 'Suchen',
    },
    {
        id: 5960,
        label: 'Fenster > Anordnen > Gleiche Zoomstufe',
        placement: 'MenuBar',
        name: 'Gleiche Zoomstufe',
    },
    {
        id: 5962,
        label: 'Fenster > Anordnen > Gleiche Position',
        placement: 'MenuBar',
        name: 'Gleiche Position',
    },
    {
        id: 5963,
        label: 'Fenster > Anordnen > Drehung angleichen',
        placement: 'MenuBar',
        name: 'Drehung angleichen',
    },
    {
        id: 5964,
        label: 'Fenster > Anordnen > Alles angleichen',
        placement: 'MenuBar',
        name: 'Alles angleichen',
    },
    {
        id: 5966,
        label: 'Datei > Freigeben für einen Review',
        placement: 'MenuBar',
        name: 'Freigeben für einen Review',
    },
    {
        id: 5967,
        label: 'Datei > Zur Bearbeitung einladen...',
        placement: 'MenuBar',
        name: 'Zur Bearbeitung einladen...',
    },
    {
        id: 5968,
        label: 'Datei > Exportieren > An Firefly Boards senden',
        placement: 'MenuBar',
        name: 'An Firefly Boards senden',
    },
    {
        id: 5980,
        label: 'Bearbeiten > Tastaturbefehle...',
        placement: 'MenuBar',
        name: 'Tastaturbefehle...',
    },
    {
        id: 5981,
        label: 'Fenster > Arbeitsbereich > Tastaturbefehle und Menüs...',
        placement: 'MenuBar',
        name: 'Tastaturbefehle und Menüs...',
    },
    {
        id: 5982,
        label: 'Bearbeiten > Menüs...',
        placement: 'MenuBar',
        name: 'Menüs...',
    },
    {
        id: 5983,
        label: 'Bearbeiten > Symbolleiste...',
        placement: 'MenuBar',
        name: 'Symbolleiste...',
    },
    {
        id: 5991,
        label: 'Ansicht > Bildschirmmodus > Standardmodus',
        placement: 'MenuBar',
        name: 'Standardmodus',
    },
    {
        id: 5992,
        label: 'Ansicht > Bildschirmmodus > Vollbildmodus mit Menüleiste',
        placement: 'MenuBar',
        name: 'Vollbildmodus mit Menüleiste',
    },
    {
        id: 5993,
        label: 'Ansicht > Bildschirmmodus > Vollbildmodus',
        placement: 'MenuBar',
        name: 'Vollbildmodus',
    },
    {
        id: 5996,
        label: 'Fenster > Anordnen > Schwebendes Fenster',
        placement: 'MenuBar',
        name: 'Schwebendes Fenster',
    },
    {
        id: 5997,
        label: 'Fenster > Anordnen > Nur schwebende Fenster',
        placement: 'MenuBar',
        name: 'Nur schwebende Fenster',
    },
    {
        id: 5998,
        label: 'Fenster > Anordnen > Alle in Registerkarten zusammenlegen',
        placement: 'MenuBar',
        name: 'Alle in Registerkarten zusammenlegen',
    },
    {
        id: 6300,
        label: 'Ebene > Neue Füllebene > Farbfläche...',
        placement: 'MenuBar',
        name: 'Farbfläche...',
    },
    {
        id: 6301,
        label: 'Ebene > Neue Füllebene > Verlauf...',
        placement: 'MenuBar',
        name: 'Verlauf...',
    },
    {
        id: 6302,
        label: 'Ebene > Neue Füllebene > Muster...',
        placement: 'MenuBar',
        name: 'Muster...',
    },
    {
        id: 6303,
        label: 'Ebene > Neue Einstellungsebene > Tonwertkorrektur...',
        placement: 'MenuBar',
        name: 'Tonwertkorrektur...',
    },
    {
        id: 6304,
        label: 'Ebene > Neue Einstellungsebene > Gradationskurven...',
        placement: 'MenuBar',
        name: 'Gradationskurven...',
    },
    {
        id: 6305,
        label: 'Ebene > Neue Einstellungsebene > Farbbalance...',
        placement: 'MenuBar',
        name: 'Farbbalance...',
    },
    {
        id: 6306,
        label: 'Ebene > Neue Einstellungsebene > Helligkeit/Kontrast...',
        placement: 'MenuBar',
        name: 'Helligkeit/Kontrast...',
    },
    {
        id: 6308,
        label: 'Ebene > Neue Einstellungsebene > Farbton/Sättigung...',
        placement: 'MenuBar',
        name: 'Farbton/Sättigung...',
    },
    {
        id: 6309,
        label: 'Ebene > Neue Einstellungsebene > Selektive Farbkorrektur...',
        placement: 'MenuBar',
        name: 'Selektive Farbkorrektur...',
    },
    {
        id: 6310,
        label: 'Ebene > Neue Einstellungsebene > Kanalmixer...',
        placement: 'MenuBar',
        name: 'Kanalmixer...',
    },
    {
        id: 6311,
        label: 'Ebene > Neue Einstellungsebene > Verlaufsumsetzung...',
        placement: 'MenuBar',
        name: 'Verlaufsumsetzung...',
    },
    {
        id: 6312,
        label: 'Ebene > Neue Einstellungsebene > Fotofilter...',
        placement: 'MenuBar',
        name: 'Fotofilter...',
    },
    {
        id: 6313,
        label: 'Ebene > Neue Einstellungsebene > Umkehren...',
        placement: 'MenuBar',
        name: 'Umkehren...',
    },
    {
        id: 6314,
        label: 'Ebene > Neue Einstellungsebene > Schwellenwert...',
        placement: 'MenuBar',
        name: 'Schwellenwert...',
    },
    {
        id: 6315,
        label: 'Ebene > Neue Einstellungsebene > Tontrennung...',
        placement: 'MenuBar',
        name: 'Tontrennung...',
    },
    {
        id: 6332,
        label: 'Ebene > Smartobjekte > Inhalt bearbeiten',
        placement: 'MenuBar',
        name: 'Inhalt bearbeiten',
    },
    {
        id: 6333,
        label: 'Ebene > Smartobjekte > Inhalt ersetzen...',
        placement: 'MenuBar',
        name: 'Inhalt ersetzen...',
    },
    {
        id: 6334,
        label: 'Ebene > Smartobjekte > Inhalt exportieren...',
        placement: 'MenuBar',
        name: 'Inhalt exportieren...',
    },
    {
        id: 6337,
        label: 'Ebene > Neue Einstellungsebene > Color Lookup...',
        placement: 'MenuBar',
        name: 'Color Lookup...',
    },
    {
        id: 6339,
        label: 'Ebene > Smartobjekte > In verknüpftes Smartobjekt konvertieren...',
        placement: 'MenuBar',
        name: 'In verknüpftes Smartobjekt konvertieren...',
    },
    {
        id: 6340,
        label: 'Ebene > Smartobjekte > Erneut mit Datei verknüpfen...',
        placement: 'MenuBar',
        name: 'Erneut mit Datei verknüpfen...',
    },
    {
        id: 6341,
        label: 'Ebene > Smartobjekte > Erneut mit Bibliotheksgrafik verknüpfen...',
        placement: 'MenuBar',
        name: 'Erneut mit Bibliotheksgrafik verknüpfen...',
    },
    {
        id: 6342,
        label: 'Ebene > Smartobjekte > Geänderten Inhalt aktualisieren',
        placement: 'MenuBar',
        name: 'Geänderten Inhalt aktualisieren',
    },
    {
        id: 6343,
        label: 'Ebene > Smartobjekte > Alle geänderten Inhalte aktualisieren',
        placement: 'MenuBar',
        name: 'Alle geänderten Inhalte aktualisieren',
    },
    {
        id: 6345,
        label: 'Ebene > Smartobjekte > Verknüpftes Smartobjekt einbetten',
        placement: 'MenuBar',
        name: 'Verknüpftes Smartobjekt einbetten',
    },
    {
        id: 6346,
        label: 'Ebene > Smartobjekte > Alle verknüpften Smartobjekte einbetten',
        placement: 'MenuBar',
        name: 'Alle verknüpften Smartobjekte einbetten',
    },
    {
        id: 6347,
        label: 'Ebene > Smartobjekte > Transformation zurücksetzen',
        placement: 'MenuBar',
        name: 'Transformation zurücksetzen',
    },
    {
        id: 6348,
        label: 'Ebene > Neue Einstellungsebene > Schwarzweiß...',
        placement: 'MenuBar',
        name: 'Schwarzweiß...',
    },
    {
        id: 6351,
        label: 'Ebene > Videoebenen > Neue Videoebene aus Datei...',
        placement: 'MenuBar',
        name: 'Neue Videoebene aus Datei...',
    },
    {
        id: 6352,
        label: 'Ebene > Videoebenen > Neue leere Videoebene',
        placement: 'MenuBar',
        name: 'Neue leere Videoebene',
    },
    {
        id: 6353,
        label: 'Ebene > Videoebenen > Leeren Frame einfügen',
        placement: 'MenuBar',
        name: 'Leeren Frame einfügen',
    },
    {
        id: 6354,
        label: 'Ebene > Videoebenen > Frame duplizieren',
        placement: 'MenuBar',
        name: 'Frame duplizieren',
    },
    {
        id: 6355,
        label: 'Ebene > Videoebenen > Frame löschen',
        placement: 'MenuBar',
        name: 'Frame löschen',
    },
    {
        id: 6356,
        label: 'Ebene > Videoebenen > Footage interpretieren...',
        placement: 'MenuBar',
        name: 'Footage interpretieren...',
    },
    {
        id: 6357,
        label: 'Ebene > Videoebenen > Footage ersetzen...',
        placement: 'MenuBar',
        name: 'Footage ersetzen...',
    },
    {
        id: 6358,
        label: 'Ebene > Videoebenen > Geändertes Video anzeigen',
        placement: 'MenuBar',
        name: 'Geändertes Video anzeigen',
    },
    {
        id: 6360,
        label: 'Ebene > Videoebenen > Frame wiederherstellen',
        placement: 'MenuBar',
        name: 'Frame wiederherstellen',
    },
    {
        id: 6361,
        label: 'Ebene > Videoebenen > Alle Frames wiederherstellen',
        placement: 'MenuBar',
        name: 'Alle Frames wiederherstellen',
    },
    {
        id: 6362,
        label: 'Datei > Importieren > Videoframes in Ebenen...',
        placement: 'MenuBar',
        name: 'Videoframes in Ebenen...',
    },
    {
        id: 6363,
        label: 'Ebene > Videoebenen > Frame neu laden',
        placement: 'MenuBar',
        name: 'Frame neu laden',
    },
    {
        id: 6400,
        label: 'Ansicht > 32-Bit-Vorschauoptionen...',
        placement: 'MenuBar',
        name: '32-Bit-Vorschauoptionen...',
    },
    {
        id: 6432,
        label: 'Ebene > Smartobjekte > Stapelmodus > Ohne',
        placement: 'MenuBar',
        name: 'Ohne',
    },
    {
        id: 6440,
        label: 'Filter > Für Smartfilter konvertieren',
        placement: 'MenuBar',
        name: 'Für Smartfilter konvertieren',
    },
    {
        id: 6478,
        label: 'Fenster > Eigenschaften',
        placement: 'MenuBar',
        name: 'Eigenschaften',
    },
    {
        id: 6479,
        label: 'Fenster > Korrekturen',
        placement: 'MenuBar',
        name: 'Korrekturen',
    },
    {
        id: 6651,
        label: 'Ebene > Neue Einstellungsebene > Klarheit und Dunstentfernung...',
        placement: 'MenuBar',
        name: 'Klarheit und Dunstentfernung...',
    },
    {
        id: 6652,
        label: 'Ebene > Neue Einstellungsebene > Körnung...',
        placement: 'MenuBar',
        name: 'Körnung...',
    },
    {
        id: 7763,
        label: 'Fenster > Verläufe',
        placement: 'MenuBar',
        name: 'Verläufe',
    },
    {
        id: 7767,
        label: 'Fenster > Muster',
        placement: 'MenuBar',
        name: 'Muster',
    },
    {
        id: 7772,
        label: 'Fenster > Formen',
        placement: 'MenuBar',
        name: 'Formen',
    },
    {
        id: 7785,
        label: 'Fenster > Content Credentials (Beta)',
        placement: 'MenuBar',
        name: 'Content Credentials (Beta)',
    },
    {
        id: 7788,
        label: 'Fenster > Materialien',
        placement: 'MenuBar',
        name: 'Materialien',
    },
    {
        id: 7789,
        label: 'Filter > Parametrische Filter...',
        placement: 'MenuBar',
        name: 'Parametrische Filter...',
    },
    {
        id: 7800,
        label: 'Bild > Datensatz anwenden...',
        placement: 'MenuBar',
        name: 'Datensatz anwenden...',
    },
    {
        id: 7802,
        label: 'Bild > Variablen > Definieren...',
        placement: 'MenuBar',
        name: 'Definieren...',
    },
    {
        id: 7803,
        label: 'Bild > Variablen > Datensätze...',
        placement: 'MenuBar',
        name: 'Datensätze...',
    },
    {
        id: 7805,
        label: 'Datei > Importieren > Variablen-Datensätze...',
        placement: 'MenuBar',
        name: 'Variablen-Datensätze...',
    },
    {
        id: 7806,
        label: 'Datei > Exportieren > Datensätze als Dateien...',
        placement: 'MenuBar',
        name: 'Datensätze als Dateien...',
    },
    {
        id: 7900,
        label: 'Bild > Analyse > Zähl-Werkzeug',
        placement: 'MenuBar',
        name: 'Zähl-Werkzeug',
    },
    {
        id: 7930,
        label: 'Fenster > Anwendungsrahmen',
        placement: 'MenuBar',
        name: 'Anwendungsrahmen',
    },
    {
        id: 8820,
        label: 'Filter > Neural Filters...',
        placement: 'MenuBar',
        name: 'Neural Filters...',
    },
    {
        id: 9066,
        label: 'Schrift > Bedienfelder > Zeichenformatebedienfeld',
        placement: 'MenuBar',
        name: 'Zeichenformatebedienfeld',
    },
    {
        id: 9066,
        label: 'Fenster > Zeichenformate',
        placement: 'MenuBar',
        name: 'Zeichenformate',
    },
    {
        id: 9067,
        label: 'Schrift > Bedienfelder > Absatzformatebedienfeld',
        placement: 'MenuBar',
        name: 'Absatzformatebedienfeld',
    },
    {
        id: 9067,
        label: 'Fenster > Absatzformate',
        placement: 'MenuBar',
        name: 'Absatzformate',
    },
    {
        id: 9068,
        label: 'Schrift > Bedienfelder > Glyphenbedienfeld',
        placement: 'MenuBar',
        name: 'Glyphenbedienfeld',
    },
    {
        id: 9068,
        label: 'Fenster > Glyphen',
        placement: 'MenuBar',
        name: 'Glyphen',
    },
    {
        id: 9086,
        label: 'Schrift > OpenType > Ausrichtungsalternativen',
        placement: 'MenuBar',
        name: 'Ausrichtungsalternativen',
    },
    {
        id: 9087,
        label: 'Schrift > Fehlende Schriften verwalten',
        placement: 'MenuBar',
        name: 'Fehlende Schriften verwalten',
    },
    {
        id: 9100,
        label: 'Schrift > Sprachoptionen > Standardfunktionen',
        placement: 'MenuBar',
        name: 'Standardfunktionen',
    },
    {
        id: 9101,
        label: 'Schrift > Sprachoptionen > Ostasiatische Funktionen',
        placement: 'MenuBar',
        name: 'Ostasiatische Funktionen',
    },
    {
        id: 9102,
        label: 'Schrift > Sprachoptionen > Nahöstliche Funktionen',
        placement: 'MenuBar',
        name: 'Nahöstliche Funktionen',
    },
    {
        id: 9109,
        label: 'Schrift > Vorschaugröße für Schrift > Ohne',
        placement: 'MenuBar',
        name: 'Ohne',
    },
    {
        id: 9110,
        label: 'Schrift > Vorschaugröße für Schrift > Klein',
        placement: 'MenuBar',
        name: 'Klein',
    },
    {
        id: 9111,
        label: 'Schrift > Vorschaugröße für Schrift > Mittel',
        placement: 'MenuBar',
        name: 'Mittel',
    },
    {
        id: 9112,
        label: 'Schrift > Vorschaugröße für Schrift > Groß',
        placement: 'MenuBar',
        name: 'Groß',
    },
    {
        id: 9113,
        label: 'Schrift > Vorschaugröße für Schrift > Sehr groß',
        placement: 'MenuBar',
        name: 'Sehr groß',
    },
    {
        id: 9114,
        label: 'Schrift > Vorschaugröße für Schrift > Riesig',
        placement: 'MenuBar',
        name: 'Riesig',
    },
    {
        id: 9119,
        label: 'Schrift > Platzhaltertext einfügen',
        placement: 'MenuBar',
        name: 'Platzhaltertext einfügen',
    },
    {
        id: 9121,
        label: 'Schrift > Standardschriftstile laden',
        placement: 'MenuBar',
        name: 'Standardschriftstile laden',
    },
    {
        id: 9122,
        label: 'Schrift > Standardschriftstile speichern',
        placement: 'MenuBar',
        name: 'Standardschriftstile speichern',
    },
    {
        id: 9123,
        label: 'Schrift > Passende Schrift finden...',
        placement: 'MenuBar',
        name: 'Passende Schrift finden...',
    },
    {
        id: 9130,
        label: 'Schrift > Sprachoptionen > Standardmäßige vertikale Ausrichtung (Roman)',
        placement: 'MenuBar',
        name: 'Standardmäßige vertikale Ausrichtung (Roman)',
    },
    {
        id: 9131,
        label: 'Schrift > Sprachoptionen > Tate-chu-yoko',
        placement: 'MenuBar',
        name: 'Tate-chu-yoko',
    },
    {
        id: 9132,
        label: 'Schrift > Sprachoptionen > Zeilenabstand Oberlinie zu Oberlinie',
        placement: 'MenuBar',
        name: 'Zeilenabstand Oberlinie zu Oberlinie',
    },
    {
        id: 9133,
        label: 'Schrift > Sprachoptionen > Zeilenabstand Unterlinie zu Unterlinie',
        placement: 'MenuBar',
        name: 'Zeilenabstand Unterlinie zu Unterlinie',
    },
    {
        id: 9137,
        label: 'Schrift > Sprachoptionen > Kashidas',
        placement: 'MenuBar',
        name: 'Kashidas',
    },
    {
        id: 9138,
        label: 'Schrift > Sprachoptionen > Standardrichtung',
        placement: 'MenuBar',
        name: 'Standardrichtung',
    },
    {
        id: 9139,
        label: 'Schrift > Sprachoptionen > Zeichenrichtung von links nach rechts',
        placement: 'MenuBar',
        name: 'Zeichenrichtung von links nach rechts',
    },
    {
        id: 9140,
        label: 'Schrift > Sprachoptionen > Zeichenrichtung von rechts nach links',
        placement: 'MenuBar',
        name: 'Zeichenrichtung von rechts nach links',
    },
    {
        id: 9143,
        label: 'Bearbeiten > Einfügen Spezial > Ohne Formatierung einfügen',
        placement: 'MenuBar',
        name: 'Ohne Formatierung einfügen',
    },
    {
        id: 9220,
        label: 'Ebene > Neu > Zeichenfläche...',
        placement: 'MenuBar',
        name: 'Zeichenfläche...',
    },
    {
        id: 9221,
        label: 'Ebene > Neu > Zeichenfläche aus Gruppe',
        placement: 'MenuBar',
        name: 'Zeichenfläche aus Gruppe',
    },
    {
        id: 9222,
        label: 'Ebene > Neu > Zeichenfläche aus Ebenen…',
        placement: 'MenuBar',
        name: 'Zeichenfläche aus Ebenen…',
    },
    {
        id: 9252,
        label: 'Ebene > Neu > Rahmen aus Ebenen ...',
        placement: 'MenuBar',
        name: 'Rahmen aus Ebenen ...',
    },
    {
        id: 9255,
        label: 'Ebene > Neu > In Rahmen konvertieren',
        placement: 'MenuBar',
        name: 'In Rahmen konvertieren',
    },
    {
        id: 9600,
        label: 'Fenster > Kontextbezogene Taskleiste',
        placement: 'MenuBar',
        name: 'Kontextbezogene Taskleiste',
    },
    {
        id: 11600,
        label: 'Ebene > Harmonisieren',
        placement: 'MenuBar',
        name: 'Harmonisieren',
    },
    {
        id: 15004,
        label: 'Hilfe > Systeminformationen...',
        placement: 'MenuBar',
        name: 'Systeminformationen...',
    },
    {
        id: 15009,
        label: 'Hilfe > GPU-Kompatibilität...',
        placement: 'MenuBar',
        name: 'GPU-Kompatibilität...',
    },
    {
        id: 15019,
        label: 'Hilfe > Mehr über generative Credits erfahren',
        placement: 'MenuBar',
        name: 'Mehr über generative Credits erfahren',
    },
    {
        id: 15020,
        label: 'Hilfe > Benutzungsrichtlinien zur generativen KI von Adobe',
        placement: 'MenuBar',
        name: 'Benutzungsrichtlinien zur generativen KI von Adobe',
    },
    {
        id: 15201,
        label: 'Datei > Adobe Stock durchsuchen…',
        placement: 'MenuBar',
        name: 'Adobe Stock durchsuchen…',
    },
    {
        id: 15202,
        label: 'Datei > Adobe Express-Vorlagen durchsuchen...',
        placement: 'MenuBar',
        name: 'Adobe Express-Vorlagen durchsuchen...',
    },
    {
        id: 15203,
        label: 'Hilfe > Praktische Tutorials...',
        placement: 'MenuBar',
        name: 'Praktische Tutorials...',
    },
    {
        id: 15204,
        label: 'Hilfe > Neuerungen...',
        placement: 'MenuBar',
        name: 'Neuerungen...',
    },
    {
        id: 17001,
        label: 'Bearbeiten > Perspektivische Verformung',
        placement: 'MenuBar',
        name: 'Perspektivische Verformung',
    },
    {
        id: 20006,
        label: 'Datei > Versionsverlauf',
        placement: 'MenuBar',
        name: 'Versionsverlauf',
    },
    {
        id: 20007,
        label: 'Fenster > Versionsverlauf',
        placement: 'MenuBar',
        name: 'Versionsverlauf',
    },
    {
        id: 20008,
        label: 'Fenster > Kommentare',
        placement: 'MenuBar',
        name: 'Kommentare',
    },
    {
        id: 21000,
        label: 'Ebene > Smartobjekte > In Ebenen konvertieren',
        placement: 'MenuBar',
        name: 'In Ebenen konvertieren',
    },
    {
        id: 21001,
        label: 'Ansicht > Ebene(n) an Bildschirm anpassen',
        placement: 'MenuBar',
        name: 'Ebene(n) an Bildschirm anpassen',
    },
    {
        id: 22003,
        label: 'Ansicht > Hilfslinien > Ausgewählte Hilfslinien bearbeiten',
        placement: 'MenuBar',
        name: 'Ausgewählte Hilfslinien bearbeiten',
    },
    {
        id: 22004,
        label: 'Ansicht > Hilfslinien > Ausgewählte Hilfslinien löschen',
        placement: 'MenuBar',
        name: 'Ausgewählte Hilfslinien löschen',
    },
    {
        id: 22100,
        label: 'Ebene > Alle Objekte maskieren',
        placement: 'MenuBar',
        name: 'Alle Objekte maskieren',
    },
    {
        id: 23150,
        label: 'Filter > Letzter Filter',
        placement: 'MenuBar',
        name: 'Letzter Filter',
    },
    {
        id: 23151,
        label: 'Filter > Letzter Filter',
        placement: 'MenuBar',
        name: 'Letzter Filter',
    },
    {
        id: 23152,
        label: 'Filter > Letzter Filter',
        placement: 'MenuBar',
        name: 'Letzter Filter',
    },
    {
        id: 23153,
        label: 'Filter > Letzter Filter',
        placement: 'MenuBar',
        name: 'Letzter Filter',
    },
    {
        id: 25070,
        label: 'Bearbeiten > Objekt drehen',
        placement: 'MenuBar',
        name: 'Objekt drehen',
    },
    {
        id: 26010,
        label: 'Bearbeiten > Reflexionsentfernung ...',
        placement: 'MenuBar',
        name: 'Reflexionsentfernung ...',
    },
    {
        id: 30900,
        label: 'Datei > Kostenlose Adobe Stock-Bilder platzieren...',
        placement: 'MenuBar',
        name: 'Kostenlose Adobe Stock-Bilder platzieren...',
    },
    {
        id: 'paintbrushTool',
        label: 'Pinsel',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: 'Korrekturpinsel-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: 'Buntstift',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: 'Farbe-ersetzen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: 'Misch-Pinsel',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: 'Radiergummi-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: 'Hintergrund-Radiergummi-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: 'Kopierstempel',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: 'Musterstempel',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: 'Reparatur-Pinsel',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: 'Protokoll-Pinsel',
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: 'Kunst-Protokollpinsel',
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: 'Wischwerkzeug',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: 'Weichzeichner-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: 'Scharfzeichner-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: 'Abwedler-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: 'Nachbelichter-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: 'Schwamm',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: 'Rote-Augen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: 'Auswahlwerkzeug: Rechteck',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: 'Auswahlwerkzeug: Ellipse',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: 'Auswahlwerkzeug: Einzelne Zeile',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: 'Auswahlwerkzeug: Einzelne Spalte',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: 'Verschieben-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: 'Zeichenflächen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: 'Lasso-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: 'Auswahlpinsel-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: 'Objektauswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: 'Polygon-Lasso-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: 'Magnetisches-Lasso-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: 'Zauberstab-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: 'Schnellauswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: 'Freistellungs-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: 'Perspektivisches Freistellungswerkzeug',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: 'Slice-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: 'Slice-Auswahlwerkzeug',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: 'Magischer-Radiergummi-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: 'Verlaufswerkzeug',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: 'Füllwerkzeug',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: 'Pfadauswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: 'Direktauswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: 'Zeichenstift-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: 'Freiform-Zeichenstift-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: 'Rundungszeichenstift-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: 'Ankerpunkt-hinzufügen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: 'Ankerpunkt-löschen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: 'Punkt-umwandeln-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: 'Horizontales Text-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: 'Vertikales Text-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: 'Horizontales Text-Maskierungswerkzeug',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: 'Vertikales Text-Maskierungswerkzeug',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: 'Rechteck-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: 'Ellipse-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: 'Dreieckwerkz.',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: 'Polygon-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: 'Linienzeichner-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: 'Eigene-Form-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'StarTool',
        label: 'Stern-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: 'Rahmen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: 'Pipette',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: 'Farbprüfer-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: 'Lineal-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: 'Anmerkungs-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: 'Hand-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: 'Ansichtdrehungs-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: 'Zoom-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: 'Ausbessern-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: 'Inhaltsbasiert verschieben-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: 'Bereichsreparatur-Pinsel',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: 'Entfernen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: 'Symbolleiste bearbeiten...',
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: 'Zähl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: 'Aktionen',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: 'Verläufe',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: 'Stile',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: 'Farbfelder',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: 'Muster',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: 'Histogramm',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: 'Info',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: 'Pfade',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: 'Formen',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: 'Werkzeugvorgaben',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: 'Farbe',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: 'Kanäle',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: 'Ebenen',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: 'Ebenenkomposition',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: 'Zeitleiste',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: 'Kopierquelle',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: 'Messprotokoll',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.hdrpreview',
        label: 'HDR-Vorschau',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: 'Protokoll',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: 'Navigator',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: 'Zeichen',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: 'Absatz',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: 'Zeichenformate',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: 'Absatzformate',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: 'Glyphen',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: 'Anmerkungen',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: 'Eigenschaften',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cai.uxp/panel',
        label: 'Content Credentials (Beta)',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cclibrariespanel/ccLibrariesPanel',
        label: 'Bibliotheken',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.ccx.comments-webview/ccx-comments-uxp-webview',
        label: 'Kommentare',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: 'Kontextleiste : Dynamischer Text',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: 'Bedienfeld : Dynamischer Text',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: 'Werkzeug : Dynamischer Text',
        placement: 'Option',
    },
];
